import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  EventEmitter, Input,
  OnDestroy,
  OnInit, Output,
  ViewChild,
  ViewRef,
  AfterViewInit,
  input
} from '@angular/core';
import {CommonModule} from "@angular/common";
import {FormsModule} from "@angular/forms";
import {SwitchBoard} from "../../../services/SwitchBoard";
import {LoadingService} from "../../../services/LoadingService";
import {ActivatedRoute, Router} from "@angular/router";
import {ManageTaxStrategiesServices} from "../../../tpiq-services/manage-tax-strategies.service";
import {TaxPlanningService} from "../../../tpiq-services/tax-planning.service";
import {PROVINCES} from "../../../constants/Provinces.constants";
import {ToastService} from "../../../services/Toast.service";
import {StateRateService} from "../../../tpiq-services/state-rate.service";
import {FeatureFlagService} from "../../../tpiq-services/feature-flag.service";
import {TAX_PLANNING_TYPES} from "../../../constants/tax-planning.constants";
import {StateService} from "../../../services/StateService";
import {TOAST_TYPE} from "../../../constants/Tpiq.constants";
import {Session} from "../../../services/Session";
import {TpiqSelectDropdownComponent} from "../../../input-search/tpiq-select-dropdown/tpiq-select-dropdown.component";
import {takeUntil} from "rxjs/operators";
import {forkJoin} from 'rxjs';
import {isValidEmail} from "../../../utils/validators";
import {TaxStrategiesInfoComponent} from "../tax-strategies-info/tax-strategies-info.component";
import {ReviewTaxStrategiesComponent} from "../review-tax-strategies/review-tax-strategies.component";
import {PlanStrategyTasksComponent} from "../plan-strategy-tasks/plan-strategy-tasks.component";
import {RoiFeeNumbersComponent} from "../roi-fee-numbers/roi-fee-numbers.component";
import {ModelBasedNumeral} from "../../../directives/model-numeral";
import {FroalaEditorModule} from "angular-froala-wysiwyg";
import {FoundationInit} from "../../../directives/foundation.directive";
import * as bootstrap from 'bootstrap';
import {environment} from "../../../../environments/environment"
import { RapQuestionnaireComponent } from '../rap-questionnaires/rap-questionnaire.component';
import { ChatMessage } from '../rap-questionnaires/rap-questionnaire';
import {NumeralService} from '../../../services/Numeral.service';
import { 
  RapCommitPayload, 
  RapSessionMeta, 
  RapPlanData,
  TaxPlanCore,
  TaxPlanLine,
  RapTask,
  RapRoiFeeData,
  generateSessionId,
  generateTempStrategyId
} from '../../../models/rap-session.model';
import { trackPendoEvent } from '../../../utils-lib/pendo-track';
import {
  calculateEffectiveRate as canonicalEffectiveRate,
  isEffectiveRateMeaningful,
  recalculateTotalTax,
  shouldRecalculateEffectiveRate
} from '../../../utils-lib/tax-summary-recalc';

declare const _: any;
declare var moment: any;

@Component({
  selector: 'app-dashboard-upload-create-plan',
  standalone: true,
  imports: [CommonModule, FormsModule, TpiqSelectDropdownComponent, TaxStrategiesInfoComponent, ReviewTaxStrategiesComponent, PlanStrategyTasksComponent,
  RoiFeeNumbersComponent, ModelBasedNumeral, FroalaEditorModule, FoundationInit,RapQuestionnaireComponent],
  templateUrl: './dashboard-upload-create-plan.component.html',
  styleUrl: './dashboard-upload-create-plan.component.scss'
})
export class DashboardUploadCreatePlanComponent implements OnInit, OnDestroy, AfterViewInit {

 ngAfterViewInit() {
      this.initTooltips();
 }
 
   private initTooltips() {
     const tooltipTriggerList = Array.from(
       document.querySelectorAll('[data-bs-toggle="tooltip"]')
     );
     tooltipTriggerList.forEach((el: any) => {
       new bootstrap.Tooltip(el);
     });
   }

   private disposeTooltips() {
    const tooltipElements = Array.from(
      document.querySelectorAll('[data-bs-toggle="tooltip"]')
    );
    tooltipElements.forEach((el: any) => {
      const tooltipInstance = bootstrap.Tooltip.getInstance(el);
      if (tooltipInstance) {
        tooltipInstance.dispose();
      }
    });
  }

  reviewBtnTooltipContent: string = `
  <div class="d-flex align-items-start">
    <span>
      <strong><i class="ion-alert-circled text-warning fs-5"></i>  Important Notice</strong><br/>
      TaxPlanIQ reports are for educational use only and may be based on prior-year or preliminary data. They are not tax, legal, or accounting advice. Do not rely on these estimates for filing or implementation until reviewed and finalized by a qualified professional.
    </span>
  </div>
`;


    
  @Input() clientId: any;
  @Input() documentId: any;
  @Input() isReviewPlan: any;
  @Input() draftPlanId: any;
  @Input() planName: any;
  @Input() tabToLand: any;
  @Input() ocrStatus: any;
  @Input() chatId: any;
  @Input() questionnaireTrack: any;
  @Input() questionnaireUtilization: any;
  @Input() isRapMaximized: boolean = false;
  @Input() forceRapMode: boolean = false; // Explicitly indicates "Open in RAP" edit mode
  @Output() onCancelCreationOfStrategy: EventEmitter<any> = new EventEmitter<any>();
  @Output() onCommitSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Output() openViewJsonPopup = new EventEmitter<void>();
  @Output() ocrDataReceived = new EventEmitter<any>();
  @Output() openView1040PdfPopup = new EventEmitter<void>();
  @Output() updateQuestionarieData = new EventEmitter<any>();
  @Output() openViewQuestionariePopup = new EventEmitter<any>();

  org: string =  Session.getOrg();
  user: string = Session.getUser().id;
  destroy$: EventEmitter<void> = new EventEmitter<void>();
  editorOptions = {
    linkAlwaysBlank: true,
    heightMin: 150,
    heightMax: 150,
    toolbarButtons: ['bold', 'italic', 'underline', 'fontFamily', 'fontSize', 'color', 'insertLink', 'outdent', 'indent'],
    toolbarSticky: true,
    toolbarVisibleWithoutSelection: false,
    toolbarInline: true,
    fontFamilyDefaultSelection: 'poppins',
    fontFamily: {'Poppins-Regular': 'poppins'},
    fontFamilySelection: true,
    placeholderText: 'Internal notes about this plan',
    charCounterCount: false,
    colorsText: ['#14B5F0', '#3574e3', '#DFCF6A', '#2D62BF', '#09A4DE', '#475E79', '#3474e3', '#102D79', '#434343'],
    events : {},
    key: environment.froalaKey,
    imageUploadParam: 'file',
    // Set the image upload URL.
    imageUploadURL: `https://services.taxplaniq.com/DocumentServices/orgs/${this.org}/users/${this.user}/document`,

    // Additional upload params.
    imageUploadParams: {payload: JSON.stringify({})},

    // Set request type.
    imageUploadMethod: 'POST',

    // Set max image size to 5MB.
    imageMaxSize: 5 * 1024 * 1024,

    // Allow to upload PNG and JPG.
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
  };

  // Core focuse changes
  currentSection: any;
  client: any = {};
  tempLabelText: string;
  currentPlan: string;
  types: Array<any> = TAX_PLANNING_TYPES;
  newTaxPlan: any = {
    totalTax: 0,
    taxableIncome: 0,
    taxYear: '',
    fillingStatus : '',
    ccropFlatRate: '21',
    capGainRate: '15',
    totalTaxOverridden: false,
    customTaxRates: []
  };
  /** Tax Summary figures as they stood when the user focused the input. */
  taxableIncomeBeforeEdit: any = null;
  totalTaxBeforeEdit: any = null;
  defaultStatus: any;
  states: Array<any>;
  allTaxStrategies: any;

  selectedStrategies: Array<any> = [];
  strategiesForReview: Array<any> = [];
  reviewedStrategies: Array<any> = [];

  /** Sandbox client for RAP edit: form binds to this so source client is never mutated until commit */
  rapClient: any = null;

  /** Source plan name — stored on RAP session init, shown read-only in the Create New dialog */
  rapSourcePlanName: string = '';
  /** Controls visibility of the Create as New Plan name dialog */
  showCreateNewDialog: boolean = false;
  /** New plan name entered in the Create New dialog */
  createNewPlanName: string = '';

  secReview = {
    'clientInfo': false,
    'planInfo': false,
    'questionnaire': false,
    'strategiesInfo': false,
    'reviewInfo': false,
    'roiFeeInfo': false,
    'tasksList': false
  };
  allProvinces: Array<any> = PROVINCES.COUNTRY_PROVINCES;
  draftSaved = false;
  tasksList: Array<any> = [];
  filingStatusList: Array<any> = [
    {name: 'Single'},
    {name: 'MFJ'},
    {name: 'MFS'},
    {name: 'Head of Household'},
    {name: 'Estate'},
    {name: 'Trust'},
  ];
  ocrData: any;
  ocrSuggetions: Array<any> = [];
  years: Array<any> = [];
  currentYear: any;
  @ViewChild('scrollContainer') private scrollContainer!: ElementRef;
  portalMessage = 'NOTE: Please upgrade by emailing support@taxplaniq.com';
  year1Savings: any;
  year2Savings: any;
  @ViewChild('roiFeeInfo') roiFeeInfo;
  @ViewChild(RapQuestionnaireComponent) rapQuestionnaire!: RapQuestionnaireComponent;
  currentEnvironment: any;
  chatMessages: ChatMessage[] = [];
  onMessagesUpdate(updatedMessages: any[]) {
    this.chatMessages = updatedMessages;
    if (this.isRapEditMode && updatedMessages.length > 0) this.isRapSessionDirty = true;
  }
  newQuestionarieData = {
    ocrData: "",
    chatId: 0
  }

  // ============================================================================
  // RAP Edit Session State (Sandboxed Open-in-RAP)
  // ============================================================================
  
  /**
   * RAP session wrapper containing all plan data in isolated sandbox
   * This is the source of truth during editing
   */
  rapSession: RapCommitPayload | null = null;

  /** True once the initial OCR suggestions load completes (getRequiredSuggestionsData) */
  private rapSuggestionsReady = false;

  /** True when user has changed analysis fields or started a questionnaire chat */
  isRapSessionDirty = false;

  /**
   * Flag to prevent duplicate save attempts during final commit
   */
  isFinalSaveInProgress = false;
  
  /**
   * Flag to indicate data has been loaded and UI is ready to render
   * Used to prevent race conditions during RAP session initialization
   */
  dataLoaded = false;
  
  /**
   * Snapshot of ROI/fee data for back navigation handling
   * Allows users to navigate back without losing fee calculations
   */
  savedRoiFeeData: any = null;
  
  /**
   * Maps original strategy IDs to session keys for ID resolution
   */
  private strategyIdMap: Map<string, string> = new Map();

  /**
   * Reused canvas for measuring rendered text width of the state rate inputs,
   * so the inline "%" suffix can sit right after the typed digits.
   */
  private stateRateMeasureCanvas: HTMLCanvasElement;

  /**
   * Getter to check if we're in RAP edit mode
   * Standardizes the check for RAP edit mode throughout the component
   */
  get isRapEditMode(): boolean {
    return this.isReviewPlan && !!this.rapSession;
  }

  constructor(
    private toastService: ToastService,
    private switchBoard: SwitchBoard,
    private loadingService: LoadingService,
    private stateService: StateService,
    private _router: Router,
    private _route: ActivatedRoute,
    private changeDetectorRef: ChangeDetectorRef,
    private taxPlanningService: TaxPlanningService,
    private taxStrategyServices: ManageTaxStrategiesServices,
    private stateRateService: StateRateService,
    private featureFlag: FeatureFlagService,
    private numeralService: NumeralService,
  ) {}

  ngOnInit() {
    this._init();
  }

  _init() {
    this.currentEnvironment = environment;
    const base = this;
    this.org = Session.getOrg();
    this.user = Session.getUser().id;
    this.currentYear = new Date().getFullYear();
    const orgCountryCode: any = Session.getUser().orgCountryCode || 'US';
    this.filterStates(orgCountryCode);
    this.fillYears();
    // Get All required data like strategies, client and plan
    this.getRequiredData();
    this.switchBoard.onClickPrev
      .pipe(takeUntil(this.destroy$)).subscribe(title => {
      this.gotoDefaultPage();
    });
    this.newTaxPlan.id = this.draftPlanId;
  }
  
  get isQuestionnarieInRapEnabled() : boolean {
    return this.featureFlag.isEnabled('enableQuestionnarieInRap');
  }

  ngOnDestroy() {
    this.disposeTooltips();
    this.clearRapChatIdFromStorage();
    this.destroy$.next();
    this.destroy$.complete();
  }

  private clearRapChatIdFromStorage(): void {
    if (!this.rapSession?.meta) return;
    const { sourcePlanId, sessionId } = this.rapSession.meta;
    if (sourcePlanId && sessionId) {
      localStorage.removeItem(`chatId_${sourcePlanId}_${sessionId}`);
    }
  }

  // ============================================================================
  // RAP Edit Session Methods (Sandboxed Open-in-RAP)
  // ============================================================================

  /**
   * Initializes the sandboxed RAP edit session
   * Creates deep clone and strips database IDs for isolation
   * 
   * @param originalPlan The existing plan to edit
   */
  initializeRapEditSession(originalPlan: any) {
    // 1. Deep clone to sever all object references (prevents mutation of original)
    const clonedPlan = _.cloneDeep(originalPlan);

    // 2. Always use source plan data (no load from RAP draft table).
    // When user abandons RAP edit and reopens the plan, it loads like the first time.
    const workingData = clonedPlan;

    // 3. Create session wrapper with metadata
    this.rapSession = {
      meta: {
        action: 'COMMIT_RAP_SESSION',
        mode: 'OVERWRITE',  // Default; can be toggled to CREATE_NEW
        sourcePlanId: this.draftPlanId,
        sessionId: generateSessionId(),
        orgId: this.org,
        userId: this.user
      },
      payload: {
        planCore: this.sanitizeCoreData(workingData),
        strategies: this.createSessionStrategies(workingData.strategies || []),
        tasks: this.createSessionTasks(workingData.tasks || [], workingData.strategies || []),
        customRates: this.sanitizeCustomRates(workingData.customTaxRates || []),
        roiFee: this.extractRoiFee(workingData),
        chatId: workingData.chatId || undefined,
        ocrData: workingData.ocrData || undefined,
        ocrSuggestions: workingData.ocrSuggestions || undefined
      }
    };

    // 4. CRITICAL: Remove ID from payload that will be sent to backend
    delete this.rapSession.payload.planCore.id;

    // 5. Populate newTaxPlan for UI binding
    this.newTaxPlan = {
      ...this.rapSession.payload.planCore,
      customTaxRates: this.rapSession.payload.customRates || [],
      strategies: this.rapSession.payload.strategies || [],
      tasks: this.rapSession.payload.tasks || []
    };
    this.newTaxPlan.id = this.draftPlanId;
    // RAP edit: pre-fill plan name from source plan so Tax Summary shows it
    this.rapSourcePlanName = workingData.name || '';
    this.newTaxPlan.name = workingData.name || '';

    // 6. Populate documentId from source plan for View 1040 PDF link
    if (workingData.documentId) {
      this.documentId = workingData.documentId;
      this.newTaxPlan.documentId = workingData.documentId;
    } else if (workingData.document_id) {
      this.documentId = workingData.document_id;
      this.newTaxPlan.documentId = workingData.document_id;
    }

    // 7. Populate individual and corporate state rates if they exist in source plan
    this.populateStateRatesFromSourcePlan(workingData);

    // 7b. Remove state rate entries from Custom Rates form group (keep stateRateDropdownOptions for Review)
    this.removeStateRatesFromCustomRatesFormGroup();

    // 8. Sandbox client so edits in RAP edit never mutate the source client (cancel = no persist)
    if (this.client) {
      this.rapClient = _.cloneDeep(this.client);
    }
  }

  /**
   * Client to bind to the form: in RAP edit use sandbox (rapClient), else use live client.
   * Ensures canceling RAP edit does not persist changes to the source client.
   */
  get effectiveClient(): any {
    return (this.isRapEditMode && this.rapClient) ? this.rapClient : this.client;
  }

  /**
   * Removes state rate entries from Custom Rates form group array
   * this is like a bug fix due to backend naming inconsistency
   * After populateStateRatesFromSourcePlan() extracts state rates to simple input fields,
   * this method removes them from the customTaxRates array so they don't show BOTH:
   * - In the simple input fields (correct place)
   * - AND in the Custom Rates form group (wrong - would be duplication)
   * 
   * Called during RAP session initialization, after state rates are extracted.
   */
  /**
   * Returns the pixel offset for the inline "%" suffix so it sits right after
   * the digits the user typed, instead of pinned to the far right of the field.
   * UI-only: the measured text is never written back into newTaxPlan.
   */
  getStateRatePercentOffset(inputEl: HTMLInputElement, value: any): number {
    const paddingLeft = 8;
    if (!inputEl || value === null || value === undefined || value === '') {
      return paddingLeft;
    }
    if (!this.stateRateMeasureCanvas) {
      this.stateRateMeasureCanvas = document.createElement('canvas');
    }
    const context = this.stateRateMeasureCanvas.getContext('2d');
    const computed = window.getComputedStyle(inputEl);
    context.font = `${computed.fontSize} ${computed.fontFamily}`;
    const textWidth = context.measureText(String(value)).width;
    const inputPaddingLeft = parseFloat(computed.paddingLeft) || 0;
    const borderLeft = parseFloat(computed.borderLeftWidth) || 0;
    return inputPaddingLeft + borderLeft + textWidth + 2;
  }

  /** Strips a manually typed "%" and trims whitespace, for state rate fields. */
  private cleanStateRateInput(value: any): string {
    return String(value ?? '').replace(/%/g, '').trim();
  }

  isValidStateRateValue(value: any): boolean {
    if (value === null || value === undefined || value === '') {
      return true;
    }
    return /^-?\d+(\.\d+)?$/.test(this.cleanStateRateInput(value));
  }

  onStateRateBlur(field: 'individualStateRate' | 'corporateStateRate') {
    const raw = this.newTaxPlan?.[field];
    if (raw === null || raw === undefined || raw === '') {
      if (this.isRapEditMode) {
        this.syncStateRateFieldsToSandbox();
      }
      return;
    }
    if (!this.isValidStateRateValue(raw)) {
      this.toastService.pop(TOAST_TYPE.error, 'Invalid input - please enter proper numeric value to proceed');
      return;
    }
    this.newTaxPlan[field] = this.cleanStateRateInput(raw);
    if (this.isRapEditMode) {
      this.syncStateRateFieldsToSandbox();
    }
  }

  private removeStateRatesFromCustomRatesFormGroup() {
    if (!this.newTaxPlan.customTaxRates) {
      return;
    }

    // Preserve state rate entries for the Review screen's State Associated Rate dropdown.
    // They are removed from customTaxRates to avoid duplication in the Custom Rates form group,
    // but Review needs them for the dropdown (CA Ind State Rate, CA Corp State Rate).
    const stateRateEntries: any[] = [];
    this.newTaxPlan.customTaxRates.forEach((rate: any) => {
      try {
        const formula = typeof rate.formula === 'string'
          ? JSON.parse(rate.formula)
          : rate.formula;
        if (formula && (formula.type === 'individual' || formula.type === 'corporate')) {
          stateRateEntries.push(rate);
        }
      } catch (_) {
        // ignore
      }
    });
    if (stateRateEntries.length > 0) {
      this.newTaxPlan.stateRateDropdownOptions = stateRateEntries;
    }

    // Filter out state rate entries (formula.type='individual' or 'corporate')
    this.newTaxPlan.customTaxRates = this.newTaxPlan.customTaxRates.filter((rate: any) => {
      try {
        const formula = typeof rate.formula === 'string'
          ? JSON.parse(rate.formula)
          : rate.formula;

        // Remove state rate entries (they're now in simple input fields)
        if (formula && (formula.type === 'individual' || formula.type === 'corporate')) {
          return false;  // Remove this entry
        }

        return true;  // Keep all other custom rates
      } catch (e) {
        console.warn('[RAP] Failed to parse formula during state rate cleanup:', rate);
        return true;  // Keep if can't parse (safer)
      }
    });

    // Also update the sandbox payload to keep it in sync
    if (this.rapSession && this.rapSession.payload) {
      this.rapSession.payload.customRates = this.newTaxPlan.customTaxRates;
    }
  }

  /**
   * Populates PLAN-LEVEL state rate UI fields from source plan
   * 
   * IMPORTANT: This method ONLY populates the two state rate UI fields:
   * - newTaxPlan.individualStateRate
   * - newTaxPlan.corporateStateRate
   * 
   * It extracts these from the source plan's customTaxRates array by finding entries
   * with formula.type = 'individual' or 'corporate'.
   * 
   * All other custom rates (plan-level or strategy-level) are already copied via
   * the main customRates array initialization and are not touched here.
   * 
   * Does NOT calculate rates - only copies existing rates from database
   * This ensures we don't pre-populate fields for plans that never had state rates saved
   * 
   * After this method runs, removeStateRatesFromCustomRatesFormGroup() is called
   * to remove state rate entries from the array (prevent duplication in UI).
   * 
   * @param sourcePlanData The original plan data from the source
   */
  private populateStateRatesFromSourcePlan(sourcePlanData: any) {
    // CRITICAL: Only populate if source plan has custom rates saved in database
    // Check if customTaxRates array has the state rate entries
    if (!sourcePlanData.customTaxRates || sourcePlanData.customTaxRates.length === 0) {
      return;
    }

    // Extract ONLY state rates from customTaxRates array
    // Leave all other custom rates in the array (they're already in rapSession.payload.customRates)
    let hasIndividualRate = false;
    let hasCorporateRate = false;
    sourcePlanData.customTaxRates.forEach((customRate: any) => {
      try {
        // Safely parse formula (might be string or object)
        const formula = typeof customRate.formula === 'string' 
          ? JSON.parse(customRate.formula) 
          : customRate.formula;

        // Look for PLAN-LEVEL state rates (formula.type = 'individual' or 'corporate')
        if (formula && formula.type === 'individual') {
          this.newTaxPlan.individualStateRate = customRate.rate;
          if (this.rapSession && this.rapSession.payload && this.rapSession.payload.planCore) {
            this.rapSession.payload.planCore.individualStateRate = customRate.rate;
          }
          hasIndividualRate = true;
        } else if (formula && formula.type === 'corporate') {
          this.newTaxPlan.corporateStateRate = customRate.rate;
          if (this.rapSession && this.rapSession.payload && this.rapSession.payload.planCore) {
            this.rapSession.payload.planCore.corporateStateRate = customRate.rate;
          }
          hasCorporateRate = true;
        }
        // Note: Other custom rates (no type, or different type) are ignored here
        // They remain in rapSession.payload.customRates and will be saved as-is
      } catch (e) {
        console.warn('[RAP] Failed to parse custom rate formula:', e, customRate);
      }
    });
  }

  /**
   * Strips system fields and from plan core to prevent backend conflicts
   * @param plan Original plan data
   * @returns Clean plan core data
   */
  private sanitizeCoreData(plan: any): Partial<TaxPlanCore> {
    const { 
      id, 
      createdDate, 
      updatedDate, 
      createdBy, 
      updatedBy,
      customTaxRates,  // sent separately in payload.customRates
      strategies,      // sent separately in payload.strategies
      tasks,           // sent separately in payload.tasks
      ...cleanCore 
    } = plan;
    
    return cleanCore;
  }

  /**
   * Sanitizes custom tax rates by ensuring formula is a JSON string
   * Backend expects formula as string, but UI may have it as object
   * 
   * @param customRates Array of custom tax rate objects
   * @returns Sanitized array with formula as JSON string
   */
  private sanitizeCustomRates(customRates: any[]): any[] {
    return customRates.map(rate => {
      const sanitizedRate = { ...rate };
      
      if (sanitizedRate.formula && typeof sanitizedRate.formula === 'object') {
        sanitizedRate.formula = JSON.stringify(sanitizedRate.formula);
      }
      
      return sanitizedRate;
    });
  }

  /**
   * Converts date from MM/DD/YYYY to YYYY-MM-DD format for MySQL
   * @param dateStr Date string in MM/DD/YYYY format
   * @returns Date string in YYYY-MM-DD format or null if invalid
   */
  private convertDateToMySQLFormat(dateStr: string): string | null {
    if (!dateStr) return null;
    
    if (/^\d{4}-\d{2}-\d{2}$/.test(dateStr)) {
      return dateStr;
    }
    
    // Convert MM/DD/YYYY to YYYY-MM-DD
    const match = dateStr.match(/^(\d{1,2})\/(\d{1,2})\/(\d{4})$/);
    if (match) {
      const [, month, day, year] = match;
      return `${year}-${month.padStart(2, '0')}-${day.padStart(2, '0')}`;
    }
    
    // Try parsing with Date object as fallback
    try {
      const date = new Date(dateStr);
      if (!isNaN(date.getTime())) {
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, '0');
        const day = String(date.getDate()).padStart(2, '0');
        return `${year}-${month}-${day}`;
      }
    } catch (e) {
      console.warn('Failed to parse date:', dateStr);
    }
    
    return null;
  }

  /**
   * Sanitizes strategies by converting date fields to MySQL format
   * @param strategies Array of strategy objects
   * @returns Sanitized array with properly formatted dates
   */
  private sanitizeStrategyDates(strategies: any[]): any[] {
    return strategies.map(strat => {
      const sanitized = { ...strat };
      
      if (sanitized.goalDate) {
        sanitized.goalDate = this.convertDateToMySQLFormat(sanitized.goalDate);
      }
      if (sanitized.createTaskDate) {
        sanitized.createTaskDate = this.convertDateToMySQLFormat(sanitized.createTaskDate);
      }
      if (sanitized.startDate) {
        sanitized.startDate = this.convertDateToMySQLFormat(sanitized.startDate);
      }
      if (sanitized.endDate) {
        sanitized.endDate = this.convertDateToMySQLFormat(sanitized.endDate);
      }
      
      return sanitized;
    });
  }

  /**
   * Creates strategies with session keys for sandbox editing
   * Maps original database IDs to temporary session keys
   * 
   * @param strategies Array of original strategy objects
   * @returns Array of strategies with session keys
   */
  private createSessionStrategies(strategies: any[]): TaxPlanLine[] {
    this.strategyIdMap.clear();
    const line = (s: any) => s.reviwedData != null ? s.reviwedData : s;

    return strategies.map((s, index) => {
      const sessionKey = generateTempStrategyId(index);
      const strat = line(s);
      const originalId = s.id || strat.id;

      if (originalId) {
        this.strategyIdMap.set(originalId, sessionKey);
      }

      return {
        ...strat,
        id: sessionKey,
        originalId,
        amount: strat.amount ?? s.amount ?? 0
      };
    });
  }

  /**
   * Creates tasks linked to session strategy keys
   * Resolves original strategy IDs to session keys
   * IMPORTANT: Preserves relatedParty, taskAssignees, and firmId from source plan
   * 
   * @param tasks Array of original task objects
   * @param strategies Array of strategies (for ID mapping)
   * @returns Array of tasks with resolved session keys and preserved metadata
   */
  private createSessionTasks(tasks: any[], strategies: any[]): RapTask[] {
    return tasks.map(task => {
      const sessionStratId = this.strategyIdMap.get(task.strategyId) || task.strategyId;
      
      return {
        ...task,  // Spread captures ALL fields including relatedParty, taskAssignees, firmId
        id: undefined,  // Strip task's own ID (backend generates new)
        strategyId: sessionStratId,
        planLineId: sessionStratId,
        // Explicitly ensure these fields are preserved (for clarity)
        relatedParty: task.relatedParty,
        taskAssignees: task.taskAssignees,
        firmId: task.firmId || this.org  // Fallback to org if missing
      };
    });
  }

 /**
 * Extracts ROI fee data from draft or plan
 * @param data Plan or draft data
 * @returns Structured ROI fee data
 */
private extractRoiFee(data: any): RapRoiFeeData {
  const roi = data?.draftJson?.roiFee;

  if (roi) {
    return {
      feeLineData: roi.feeLineData || {},
      proposedY1Value: roi.proposedY1Value || 0,
      proposedY1ValueImplCalc: roi.proposedY1ValueImplCalc || []
    };
  }
  return {
    feeLineData: {},
    proposedY1Value: 0,
    proposedY1ValueImplCalc: []
  };
}

  /**
   * Syncs changes from newTaxPlan (UI model) back to sandbox
   * Called after user edits plan info section
   */
  syncPlanCoreToSandbox() {
    if (this.rapSession && this.rapSession.payload) {
      // Extract nested arrays before syncing (they belong in separate payload properties)
      const { customTaxRates, strategies, tasks, ...cleanPlanData } = this.newTaxPlan;
      
      this.rapSession.payload.planCore = {
        ...this.rapSession.payload.planCore,
        ...cleanPlanData  // Only sync plan metadata, not nested arrays
      };
      
      // Ensure ID remains stripped
      delete this.rapSession.payload.planCore.id;
    }
  }

  /**
   * Saves RAP session as draft (mid-session persistence).
   * Disabled: we do not persist RAP edit to the draft table. When user reopens the plan
   * for RAP edit, it always loads fresh from the source plan.
   */
  async saveDraft() {
    if (!this.rapSession) {
      console.warn('No RAP session to save');
      return;
    }
    // Do not save RAP edit session to draft table; always load fresh on next open
    return;
  }

  /**
   * Cancels the RAP session without saving
   * Closes the modal and returns to the plan details view
   */
  cancelRapSession() {
    this.rapClient = null;
    this.onCancelCreationOfStrategy.emit();
  }

  /** Opens the Create as New Plan dialog, pre-filling the name field with the current plan name */
  openCreateNewDialog() {
    this.normalizeTaskDueDates();
    if (!this.validTasksData()) {
      return;
    }
    this.createNewPlanName = this.newTaxPlan.name || this.rapSourcePlanName;
    this.showCreateNewDialog = true;
  }

  /** Applies the name from the dialog and commits as CREATE_NEW */
  async confirmCreateNew() {
    if (!this.createNewPlanName || !this.createNewPlanName.trim()) {
      this.toastService.pop(TOAST_TYPE.error, 'Please enter a plan name');
      return;
    }
    this.newTaxPlan.name = this.createNewPlanName.trim();
    this.showCreateNewDialog = false;
    await this.commitRapSession('CREATE_NEW');
  }

  /**
   * Returns true if custom rates list has duplicate names (same as backend StrategyUtils.validateDuplicateRateNames).
   * Used before RAP commit for both OVERWRITE and CREATE_NEW.
   */
  private hasDuplicateCustomRateNames(customRates: any[]): boolean {
    if (!customRates || customRates.length === 0) return false;
    const byName: Record<string, number> = {};
    for (const r of customRates) {
      const name = (r && r.name != null) ? String(r.name).trim() : '';
      byName[name] = (byName[name] || 0) + 1;
    }
    return Object.values(byName).some(count => count > 1);
  }

  /**
   * Commits RAP session atomically to production
   * Handles OVERWRITE or CREATE_NEW modes
   */
  async commitRapSession(mode: 'OVERWRITE' | 'CREATE_NEW' = 'OVERWRITE') {
    if (!this.rapSession || this.isFinalSaveInProgress) {
      console.warn('Cannot commit:', !this.rapSession ? 'No session' : 'Save in progress');
      return;
    }
    // Same validation as normal flow (tasks must have due dates) before commit
    this.normalizeTaskDueDates();
    if (!this.validTasksData()) {
      return;
    }

    // CRITICAL: Sync all data from UI to sandbox before commit
    this.syncPlanCoreToSandbox();
    this.syncStrategiesToSandbox();
    this.syncRoiFeeToSandbox();
    this.syncTasksToSandbox();
    this.syncStateRateFieldsToSandbox();
    if (this.rapClient) {
      this.rapSession.payload.client = { ...this.rapClient };
    }

    // CRITICAL: Re-sanitize data before commit to ensure proper formats
    // This handles any modifications made through the UI
    const sanitizedCustomRates = this.sanitizeCustomRates(this.rapSession.payload.customRates || []);
    const sanitizedStrategies = this.sanitizeStrategyDates(this.rapSession.payload.strategies || []);

    // RAP commit: same validations as backend (createClientPlan / createOrupdateStrategy)
    if (this.hasDuplicateCustomRateNames(sanitizedCustomRates)) {
      this.toastService.pop(TOAST_TYPE.error, 'One or more rates has same name');
      return;
    }

    this.isFinalSaveInProgress = true;
    this.loadingService.triggerLoadingEvent(true);

    const commitPayload: RapCommitPayload = {
      meta: {
        ...this.rapSession.meta,
        mode
      },
      payload: {
        ...this.rapSession.payload,
        customRates: sanitizedCustomRates,  // Use freshly sanitized data
        strategies: sanitizedStrategies      // Use date-sanitized strategies
      }
    };
    
    // Verify planCore structure
    if (commitPayload.payload.planCore) {
      delete commitPayload.payload.planCore['customTaxRates'];
      delete commitPayload.payload.planCore['strategies'];
      delete commitPayload.payload.planCore['tasks'];
    }
    
    // Verify first strategy structure and date formats
    if (commitPayload.payload.strategies && commitPayload.payload.strategies.length > 0) {
      const firstStrat: any = commitPayload.payload.strategies[0];
    }

    try {
      const result = await this.taxPlanningService.commitRapEditSession(commitPayload).toPromise();
    
      this.clearRapChatIdFromStorage();

      // Emit success event for parent to handle (close modal, refresh, toast)
      this.onCommitSuccess.emit({
        plan: result,
        mode: mode,
        message: 'Plan saved successfully'
      });
      
    } catch (error: any) {
      console.error('Error committing RAP session:', error);
      const message = error?.error?.message || error?.message || 'Failed to save plan';
      this.toastService.pop(TOAST_TYPE.error, message);
      this.isFinalSaveInProgress = false;
    } finally {
      this.loadingService.triggerLoadingEvent(false);
    }
  }

  /**
   * Calculates year1Savings and year2Savings from strategies in sandbox
   * Used in RAP mode when strategies change (no backend call needed)
   * 
   * Matches backend logic from ClientStrategyControllerImpl.calculateYear1Savings()
   * and calculateYear2Savings()
   */
  private calculateSavingsFromSandbox(): void {
    if (!this.rapSession || !this.rapSession.payload) return;
    
    const strategies = this.rapSession.payload.strategies || [];
    const planYear = this.rapSession.payload.planCore?.taxYear || this.newTaxPlan.taxYear;
    
    let year1Savings = 0;
    let year2Savings = 0;
    
    strategies.forEach((strategy: any) => {
      const roiAmount = Number(strategy.roiAmount) || 0;
      const stateRoiAmount = Number(strategy.stateRoiAmount) || 0;
      const totalSavings = roiAmount + stateRoiAmount;
      
      const sinceYear = Number(strategy.sinceYear) || planYear;
      const toYear = Number(strategy.toYear) || 0;
      const isRecurring = strategy.recurring || false;
      const year2 = planYear + 1;
      
      if (sinceYear === planYear || toYear === planYear ||
          (sinceYear <= planYear && toYear >= planYear) ||
          (isRecurring && sinceYear <= planYear)) {
        year1Savings += totalSavings;
      }
      
      if (sinceYear === year2 || toYear === year2 ||
          (sinceYear <= year2 && toYear >= year2) ||
          (isRecurring && sinceYear <= year2)) {
        year2Savings += totalSavings;
      }
    });
    
    this.year1Savings = Math.round(year1Savings);
    this.year2Savings = Math.round(year2Savings);
  }

  /**
   * Coordinator method to refresh all sandbox calculations when strategies change
   * 
   * This ensures:
   * 1. Strategies are synced to sandbox (with updated ROI amounts)
   * 2. Savings are recalculated from current strategies
   * 3. Savings are stored in planCore for persistence
   * 4. ROI component is notified to recalculate fee (if active)
   * 
   * Call this method:
   * - After strategy edits in Review section
   * - When navigating from Review to ROI/Fee section
   * - Before syncing ROI fee data
   */
  private refreshSandboxCalculations(): void {
    if (!this.isReviewPlan || !this.rapSession) return;
    
    // Step 1: Sync strategies to sandbox (includes updated ROI amounts from Review component)
    this.syncStrategiesToSandbox();
    
    // Step 2: Recalculate savings from current strategies
    this.calculateSavingsFromSandbox();
    
    // Step 3: Update planCore with recalculated savings (for database persistence)
    if (!this.rapSession.payload.planCore) {
      this.rapSession.payload.planCore = {};
    }
    (this.rapSession.payload.planCore as any).year1Savings = this.year1Savings;
    (this.rapSession.payload.planCore as any).year2Savings = this.year2Savings;
    
    // Step 4: Data Integrity Guard 
    // Keep newTaxPlan in sync with recalculated savings. 
    if (this.newTaxPlan) {
      this.newTaxPlan.year1Savings = this.year1Savings;
      this.newTaxPlan.year2Savings = this.year2Savings;
    }
  }

  /**
   * Handles chatId changes from RAP questionnaire component
   * Stores chatId in RAP session payload for cross-device persistence
   * @param chatId The chat ID from the questionnaire component
   */
  onChatIdChange(chatId: number): void {
    if (this.isRapEditMode && this.rapSession && this.rapSession.payload) {
      this.chatId = chatId;
      this.rapSession.payload.chatId = chatId;
    }
  }

  /**
   * Syncs strategies from UI model to sandbox
   * Called before navigating from strategies section
   */
  syncStrategiesToSandbox() {
    if (this.rapSession && this.rapSession.payload) {
      // A plan line must reference a REAL catalog strategy. A blank OR stale (non-catalog)
      // strategyId persists as an "undefined" plan row and an un-reviewable entry, and the
      // FK is unconstrained so a stale id would survive the backend (ticket 868kjbfbb).
      const catalogIds = new Set((this.allTaxStrategies || []).map((s: any) => s.id));
      if (!catalogIds.size) {
        // Catalog not loaded yet: filtering now would wrongly drop every line. Skip the sync and
        // keep the existing payload so we never commit an unresolved or emptied strategy set.
        console.warn('[868kjbfbb] syncStrategiesToSandbox skipped: tax-strategy catalog not loaded yet');
        return;
      }
      this.rapSession.payload.strategies = this.reviewedStrategies
        // Canonicalize strategy_id -> strategyId first: live-plan loads can supply snake_case only.
        .map(s => (s && !s.strategyId && s.strategy_id) ? { ...s, strategyId: s.strategy_id } : s)
        // Require a matching catalog entry, not just a truthy id.
        .filter(s => s && s.strategyId && catalogIds.has(s.strategyId))
        .map((s, index) => ({
          ...s,
          id: s.id || generateTempStrategyId(index)
        }));
    }
  }

  /**
   * Syncs Custom Rates form group entries to sandbox
   * 
   * This handles the "Custom Tax Rates" section where users add/remove custom rates.
   * Does NOT touch the two simple state rate fields (handled by syncStateRateFieldsToSandbox).
   * Does NOT touch strategy-level custom rates.
   * 
   * Called when:
   * - User adds a custom rate (addCustomTaxRate)
   * - User removes a custom rate (removeCustomTaxRate)
   */
  syncCustomRatesFormGroupToSandbox() {
    if (!this.rapSession || !this.rapSession.payload) {
      return;
    }

    // Start with existing customRates from sandbox
    let customRates = this.rapSession.payload.customRates || [];
    
    // Remove ALL plan-level custom rates (except state rates which have special type markers)
    // Keep: state rates (type='individual'/'corporate') and strategy-level rates
    customRates = customRates.filter((rate: any) => {
      try {
        const formula = typeof rate.formula === 'string' ? JSON.parse(rate.formula) : rate.formula;
        // Keep state rates (handled separately)
        if (formula.type === 'individual' || formula.type === 'corporate') {
          return true;
        }
        // Remove other plan-level custom rates (will re-add from UI)
        // Keep strategy-level rates (identified by having strategy_id)
        return rate.strategy_id != null;
      } catch (e) {
        // If can't parse, assume it's a plan-level custom rate from form group
        return false;
      }
    });

    // Add current Custom Rates form group entries from UI
    if (this.newTaxPlan.customTaxRates && this.newTaxPlan.customTaxRates.length > 0) {
      this.newTaxPlan.customTaxRates.forEach((customRate: any) => {
        // Skip if it's a state rate entry (those are handled by syncStateRateFieldsToSandbox)
        try {
          const formula = typeof customRate.formula === 'string' 
            ? JSON.parse(customRate.formula) 
            : customRate.formula;
          
          if (formula && (formula.type === 'individual' || formula.type === 'corporate')) {
            return; // Skip state rates, they're handled by the other sync method
          }
        } catch (e) {
          // Continue - not a state rate
        }

        // Add this custom rate from form group
        if (customRate.name || customRate.rate) { // Only add if it has data
          customRates.push({
            ...customRate,
            formula: typeof customRate.formula === 'string' 
              ? customRate.formula 
              : JSON.stringify(customRate.formula || {})
          });
        }
      });
    }

    // Update sandbox
    this.rapSession.payload.customRates = customRates;
    
  }

  /**
   * Syncs the TWO simple state rate input fields from main form to backend customRates array
   * 
   * UI STRUCTURE CLARIFICATION:
   * The Tax Summary form has TWO separate sections:
   * 
   * 1. MAIN FORM GROUP - Two simple input fields (what this method handles):
   *    - Individual State Rate (%) input field → newTaxPlan.individualStateRate
   *    - Corporate State Rate (%) input field → newTaxPlan.corporateStateRate
   * 
   * 2. CUSTOM RATES FORM GROUP - Separate section where users add/remove custom rates:
   *    - Already stored in newTaxPlan.customTaxRates array
   *    - This method does NOT touch this section at all
   * 
   * WHAT THIS METHOD DOES:
   * Converts the TWO simple input fields (#1) into backend customRates array entries:
   * - Removes old entries with formula.type='individual' or 'corporate'
   * - Adds new entries from current input field values
   * - Preserves ALL other custom rates (from Custom Rates form group and strategies)
   * 
   * Called when:
   * - User modifies state rate input fields (blur event)
   * - Before committing RAP session (to ensure UI changes are captured)
   */
  syncStateRateFieldsToSandbox() {
    if (!this.rapSession || !this.rapSession.payload) {
      return;
    }

    const homeState = this.newTaxPlan?.homeState;
    const hasHomeState = homeState != null && String(homeState).trim() !== '';

    let customRates = this.rapSession.payload.customRates || [];
    const originalCount = customRates.length;

    // Remove ONLY the old state rate entries (formula.type='individual' or 'corporate')
    // Keep everything else: Custom Rates form group entries, strategy-level custom rates, etc.
    customRates = customRates.filter((rate: any) => {
      try {
        const formula = typeof rate.formula === 'string' ? JSON.parse(rate.formula) : rate.formula;
        return formula.type !== 'individual' && formula.type !== 'corporate';
      } catch (e) {
        return true;
      }
    });

    // Home state cleared: remove state rate entries and explicitly set rates to 0 so payload and UI stay consistent
    if (!hasHomeState) {
      this.newTaxPlan.individualStateRate = 0;
      this.newTaxPlan.corporateStateRate = 0;
      if (this.rapSession.payload.planCore) {
        this.rapSession.payload.planCore.individualStateRate = 0;
        this.rapSession.payload.planCore.corporateStateRate = 0;
      }
      this.rapSession.payload.customRates = customRates;
      return;
    }

    const removedCount = originalCount - customRates.length;

    // Add current state rates from MAIN FORM input fields (home state is set)
    if (this.newTaxPlan.homeState) {
      // Only add individual state rate if it has a valid numeric value. A value that
      // failed onStateRateBlur()'s check (e.g. "2a") is never cleaned, so guard here
      // too - otherwise Number() below would push NaN into the commit payload and the
      // backend would reject the whole commit with a second, unrelated error toast.
      const individualRateNum = Number(String(this.newTaxPlan.individualStateRate ?? '').replace(/%/g, '').trim());
      if (this.newTaxPlan.individualStateRate !== null &&
          this.newTaxPlan.individualStateRate !== undefined &&
          this.newTaxPlan.individualStateRate !== '' &&
          Number.isFinite(individualRateNum)) {
        customRates.push({
          name: this.newTaxPlan.homeState + ' Ind State Rate',
          rate: individualRateNum,
          formula: JSON.stringify({
            actualValue: '',
            displayValue: '',
            displayValuesArray: [],
            actualValuesArray: [],
            type: 'individual'
          })
        });
      }

      // Only add corporate state rate if it has a valid numeric value (see comment above).
      const corporateRateNum = Number(String(this.newTaxPlan.corporateStateRate ?? '').replace(/%/g, '').trim());
      if (this.newTaxPlan.corporateStateRate !== null &&
          this.newTaxPlan.corporateStateRate !== undefined &&
          this.newTaxPlan.corporateStateRate !== '' &&
          Number.isFinite(corporateRateNum)) {
        customRates.push({
          name: this.newTaxPlan.homeState + ' Corp State Rate',
          rate: corporateRateNum,
          formula: JSON.stringify({
            actualValue: '',
            displayValue: '',
            displayValuesArray: [],
            actualValuesArray: [],
            type: 'corporate'
          })
        });
      }
    }

    // Update sandbox with merged custom rates
    // (main form state rate fields converted and added, Custom Rates form group entries preserved)
    this.rapSession.payload.customRates = customRates;
    
    const addedCount = customRates.length - (originalCount - removedCount);
  }

  /**
   * Syncs ROI/fee data from UI model to sandbox.
   * Callers (goToNextSection('tasksInfo'), moveToSection from 'roiFee') invoke this *before*
   * changing currentSection so roiFeeInfo ViewChild is still in the DOM.
   * When the ROI section is not in the DOM (e.g. commit from Tasks without revisiting ROI),
   * roiFeeInfo is undefined and we keep existing sandbox payload or set default empty.
   */
  syncRoiFeeToSandbox() {
    if (!this.rapSession || !this.rapSession.payload) {
      console.error('❌ [syncRoiFeeToSandbox] Cannot sync - missing rapSession or payload');
      return;
    }

    // Prefer live data from ROI component when it is rendered (user visited ROI section)
    if (this.roiFeeInfo && typeof this.roiFeeInfo.getRapEditData === 'function') {
      const roiFeeData = this.roiFeeInfo.getRapEditData();
      this.rapSession.payload.roiFee = {
        feeLineData: roiFeeData.feeLineData || {},
        proposedY1Value: roiFeeData.proposedY1Value || 0,
        proposedY1ValueImplCalc: roiFeeData.proposedY1ValueImplCalc || []
      };
      this.savedRoiFeeData = _.cloneDeep(roiFeeData);
      return;
    }

    // ROI section not in DOM (e.g. commit from Tasks): keep existing sandbox or set default
    if (this.rapSession.payload.roiFee) {
      return; // already set from init or previous visit
    }
    this.rapSession.payload.roiFee = {
      feeLineData: {},
      proposedY1Value: 0,
      proposedY1ValueImplCalc: []
    };
  }

  /**
   * Syncs tasks from UI model to sandbox
   * Called before final commit
   */
  syncTasksToSandbox() {
    if (this.rapSession && this.rapSession.payload) {
      this.rapSession.payload.tasks = this.tasksList.map(task => ({
        ...task,
        id: undefined,  // Strip task ID
        strategyId: task.strategyId,
        planLineId: task.strategyId
      }));
    }
  }

  // ============================================================================
  // End RAP Edit Session Methods (Sandboxed Open-in-RAP)
  // ============================================================================
  
  triggerShowViewJsonPopup() {
    if (this.isRapEditMode) {
      // In RAP edit mode, re-emit the latest sandbox OCR data before opening the popup.
      // rapSession.payload.ocrData is updated by re-queries and is the most current state.
      // Fall back to this.ocrData (initial session load) if payload hasn't been updated yet.
      const latestOcrData = (this.rapSession?.payload?.ocrData)
        ? JSON.parse(this.rapSession.payload.ocrData)
        : this.ocrData;
      this.ocrDataReceived.emit(latestOcrData);
    } else {
      // Normal flow: re-emit current ocrData at click time so the popup always shows
      // the latest data regardless of when formatOcrData() last ran.
      this.ocrDataReceived.emit(this.ocrData);
    }
    this.openViewJsonPopup.emit();
  }

  gotoDefaultPage() {
    const prevState = this.stateService.getPrevState();
    this.stateService.pop();
    this._router.navigate([prevState.url]);
  }

  getRequiredData() {
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    const services: any[] = [];
    const obj = {
      fromIndex: -1
    };
    services.push(this.taxPlanningService.getStrategiesList(this.org, this.user));
    services.push(this.taxPlanningService.getClient(this.org, this.user, this.clientId, false));

    forkJoin(...services)
      .subscribe({
        next: (results) => {
          this.loadingService.triggerLoadingEvent(false);
          try {
            const strategiesResult = results[0];
            const clientResult = results[1];

            // RAP edit mode requires both strategies and client; avoid partial state
            const isRapEditMode = this.isReviewPlan && this.draftPlanId;
            if (isRapEditMode && (!strategiesResult || !clientResult)) {
              console.warn('[getRequiredData] RAP edit mode requires both strategies and client; one or both missing.');
              return;
            }
            if (strategiesResult) {
              const strategies = this.formatStrategies(strategiesResult);
              this.allTaxStrategies = strategies;
            }

            if (clientResult) {
              this.client = clientResult;
              if ((this.client.firstName === 'FirstName' || this.client.firstName === 'Extracting...' || this.client.firstName === 'Not Found')) {
                this.client.firstName = '';
              }
              if ((this.client.lastName === 'Lastname' || this.client.lastName === 'Extracting...' || this.client.lastName === 'Not Found')) {
                this.client.lastName = '';
              }
              this.newTaxPlan.filingStatus = (this.newTaxPlan.filingStatus) ? this.newTaxPlan.filingStatus : 'Single';
              this.defaultStatus = this.newTaxPlan.filingStatus;
              this.newTaxPlan.clientId = this.client.id;
              this.newTaxPlan.userId = this.client.email;
              this.newTaxPlan.taxYear = this.client.defaultYear || new Date().getFullYear();
              if (!isRapEditMode) {
                this.newTaxPlan.name = (this.planName) ? this.planName : '';
              }
            }

            // Run path-specific logic only when required data is present
            if (isRapEditMode) {
              this.getDraftSelectedStrategies();
              this.getPlanData();
              if (this.draftPlanId) {
                  this.getRequiredSuggestionsData();
                } else {
                  this.getOCRSuggestions(() => this.goToSelectedSection());
                }
            } else if (strategiesResult) {
              if (this.ocrStatus === 'OCR Done') {
                if (this.draftPlanId) {
                  this.getRequiredSuggestionsData();
                } else {
                  this.getOCRSuggestions(() => this.goToSelectedSection());
                }
              } else if (this.ocrStatus === 'Error') {
                if (this.draftPlanId) {
                  this.getDraftSelectedStrategies();
                } else {
                  this.goToSelectedSection();
                }
              }
            }
          } catch (err) {
            console.error('[getRequiredData] Error processing forkJoin results:', err);
          }
        },
        error: (err) => {
          this.loadingService.triggerLoadingEvent(false);
          console.error('[getRequiredData] forkJoin failed (strategies or client request failed):', err);
        }
      });
  }

  formatStrategies(strategies) {
    let strategiesList: any[] = [];
    if (strategies && strategies.length> 0) {
      _.each(strategies, (strategy) => {
        if (!strategy.archived) {
          strategy.recurring = (strategy.recurring === 'Yearly') ? true : false;
          strategiesList.push(strategy);
        }
      });
    }
    return strategiesList;
  }


  getRequiredSuggestionsData() {
    this.loadingService.triggerLoadingEvent(true);
    const base = this;
    const services: any[] = [];

    services.push(this.taxPlanningService.getOCRSuggestions(this.org, this.user, this.clientId, this.documentId));
    services.push(this.taxPlanningService.draftSelectedStrategies(this.org, this.user, this.draftPlanId));
    forkJoin(...services)
      .subscribe(results => {
        this.loadingService.triggerLoadingEvent(false);

        if (results[0]) {
          this.formatOcrData(results[0]);
        }

        if (results[1]) {
          let responseData: any = results[1];
          setTimeout(() => {
            this.reviewedStrategies = responseData.suggessions || [];
            this.formatDraftStrategies(responseData.suggessions || []);
            this.year1Savings = responseData.year1Savings || 0;
            this.year2Savings = responseData.year2Savings || 0;
            this.goToSelectedSection();
          },50);
        }

        this.rapSuggestionsReady = true;
        this.isRapSessionDirty = false;

      });
  }

  formatOcrData(response) {
    this.ocrData = response.ocrdata;
    this.ocrDataReceived.emit(response.ocrdata);
    this.newTaxPlan.totalTax = Number(this.ocrData.us_1040_total_tax) || 0;
    this.newTaxPlan.taxableIncome = Number(this.ocrData.us_1040_line_15_taxable_income) || 0;
    this.newTaxPlan.homeState = this.ocrData.us_1040_state || '';
    this.newTaxPlan.filingStatus = this.ocrData.us_1040_filing_status
      ? this.normalizeFilingStatus(this.ocrData.us_1040_filing_status)
      : (this.newTaxPlan.filingStatus || this.client?.filingStatus || '');
    this.defaultStatus = this.newTaxPlan.filingStatus;
    this.populateStateRates();
    this.calculateEffectiveRate();
    this.calculateMarginalRate();
    this.calculateCapGainsRate();
    if (response.suggestions && response.suggestions.length > 0) {
      this.ocrSuggetions = this.formatedAiSuggestedStrategies(response.suggestions);
      this.ocrSuggetions = _.orderBy(this.ocrSuggetions, 'planAmount', 'desc');
    }
  }

  // ============================================================================
  // AI Strategy Re-query Helper Methods
  // ============================================================================

  /**
   * Executes AI strategy re-query with hybrid payload.
   * Handles both skip and next button scenarios (with/without questionnaire).
   * 
   * This method consolidates the re-query logic to eliminate code duplication
   * and ensure consistent behavior across all questionnaire exit paths.
   * 
   * @param chatUpdates - Optional chat updates from questionnaire (null if skipped/not started)
   * @param section - Target section to navigate to (usually 'strategiesInfo')
   */
  private executeStrategyRequery(chatUpdates: any = null, section: string = 'strategiesInfo'): void {
    // Use the getter property for consistency
    const isRapEditMode = this.isRapEditMode;
    
    // 1. Feature Flag Guard: Only proceed in Normal Flow if enabled.
    if (!isRapEditMode && !this.isQuestionnarieInRapEnabled) {
      this.navigateToStrategiesSection(section);
      return;
    }

    // 2. Dirty Guard (RAP Mode only): Skip re-query if nothing changed and suggestions already loaded.
    if (isRapEditMode && !this.isRapSessionDirty && !chatUpdates && this.ocrSuggetions?.length > 0) {
      this.navigateToStrategiesSection(section);
      return;
    }

    // 3. Stale Data Guard (RAP Mode only): Ensure async OCR load has completed.
    // In RAP edit mode, OCR data loads asynchronously after session initialization.
    // If documentId exists but ocrData is missing, it might still be loading.
    if (isRapEditMode && this.documentId && !this.ocrData) {
      this.loadingService.triggerLoadingEvent(false); // Kill spinner if active
      this.toastService.pop(
        TOAST_TYPE.warning, 
        'Document data is still loading. Please wait a moment and try again.'
      );
      this.navigateToStrategiesSection(section);
      return;
    }

    // 4. Universal Data Integrity Check:
    if (!this.documentId) {
      // Scenario: A plan created manually without an uploaded 1040.
      // We can't do OCR re-query without a document, so we just navigate.
      this.navigateToStrategiesSection(section);
      return;
    }

    if (!this.ocrData) {
      // Scenario: Document exists, but OCR processing failed or JSON is missing.
      console.warn('AI Re-query aborted: No OCR baseline data found for document:', this.documentId);
      this.navigateToStrategiesSection(section);
      return;
    }

    // --- Start Re-query Process ---

    // Ensure status allows the UI to render the AI Strategies tab.
    if (this.ocrStatus === 'Error' || !this.ocrStatus) {
      this.ocrStatus = 'Success';
    }

    this.loadingService.triggerLoadingEvent(true);

    // HYBRID PAYLOAD: In both flows, this.newTaxPlan represents the "Current Working State."
    // In RAP Edit, this is the sandboxed/dirty state containing manual UI overrides.
    const planData = this.newTaxPlan;

    const hybridPayload = this.createHybridOcrPayload(this.ocrData, planData, chatUpdates);

    // Attach the identifier required by the RAP suggestion endpoint.
    // Backend requires ocr_request_id (primary) or document_id (fallback) to resolve the AI task ID.
    // this.documentId is set from the source plan's document_id column on initial RAP edit load.
    if (isRapEditMode) {
      if (this.newTaxPlan?.ocrRequestId) {
        hybridPayload.ocr_request_id = this.newTaxPlan.ocrRequestId;
      } else {
        hybridPayload.document_id = this.documentId;
      }
    }

    // RAP edit mode uses the dedicated RAP suggestion endpoint — same behavior but:
    // - No DB lookup (entire state is in the payload)
    // - Accepts the full hybrid payload (OCR baseline + sandbox plan edits + chat updates)
    // Normal flow uses the standard questionnaire suggestion endpoint (documentId-based).
    const requery$ = isRapEditMode
      ? this.taxPlanningService.getRapQuestionnarieOCRSuggestions(this.org, this.user, hybridPayload)
      : this.taxPlanningService.getQuestionnarieOCRSuggestions(this.org, this.user, this.documentId, false, hybridPayload);

    requery$.subscribe({
        next: (response) => {
          this.isRapSessionDirty = false;
          this.processAiResponse(response, section);
        },
        error: (error) => {
          this.handleAiRequeryError(error, section);
        }
      });
  }

  /**
   * Processes AI response and updates UI
   * Consolidates formatting, sorting, and navigation logic
   * 
   * @param response - API response containing suggestions and chat_id
   * @param section - Target section to navigate to
   */
  private processAiResponse(response: any, section: string): void {
    if (response && response.suggestions && response.suggestions.length > 0) {
      this.ocrSuggetions = this.formatAndSortAiSuggestions(response.suggestions);
    }

    if (response?.chat_id) {
      this.chatId = response.chat_id;
      // In RAP edit mode, propagate the updated chatId into the session payload
      // so it is included in the commit and survives cross-device session continuity.
      if (this.isRapEditMode && this.rapSession?.payload) {
        this.rapSession.payload.chatId = response.chat_id;
      }
    } else if (!this.chatId) {
      this.chatId = 0;
    }

    this.chatMessages = [];

    this.secReview.questionnaire = true;

    this.navigateToStrategiesSection(section);
    
    this.loadingService.triggerLoadingEvent(false);
  }

  /**
   * Handles errors during AI re-query
   * Provides user feedback and graceful degradation
   * 
   * @param error - Error object from API call
   * @param section - Target section to navigate to
   */
  private handleAiRequeryError(error: any, section: string): void {
    console.error('Error fetching questionnaire OCR suggestions:', error);
    
    this.toastService.pop(
      TOAST_TYPE.error, 
      'Failed to refresh AI suggestions. Showing existing suggestions.'
    );

    this.navigateToStrategiesSection(section);
    this.loadingService.triggerLoadingEvent(false);
  }

  /**
   * Navigates to strategies section with consistent state management
   * 
   * @param section - Target section (usually 'strategiesInfo')
   */
  private navigateToStrategiesSection(section: string): void {
    this.setSectionReviewedValuse(section);
    this.currentSection = section;
  }

  /**
   * Formats and sorts AI suggested strategies
   * Centralizes the logic used in multiple places
   * 
   * @param suggestions - Raw suggestions array from API
   * @returns Formatted and sorted suggestions array
   */
  private formatAndSortAiSuggestions(suggestions: any[]): any[] {
    if (!suggestions || suggestions.length === 0) {
      return [];
    }
    
    const formatted = this.formatedAiSuggestedStrategies(suggestions);
    return _.orderBy(formatted, 'planAmount', 'desc');
  }

  /**
   * Creates a hybrid OCR payload by merging original OCR data with current sandbox state.
   * Ensures AI suggestions reflect original 1040 data AND user's manual edits.
   * When background chat fails or returns empty, baseline OCR + sandbox still preserves Plan Info edits.
   *
   * Precedence: chatUpdates > sandboxPlan > originalOcrData (sandbox always wins over original for mapped fields).
   *
   * @param originalOcrData - The original OCR JSON from the uploaded 1040
   * @param sandboxPlan - The current state of the plan in the RAP sandbox (this.newTaxPlan)
   * @param chatUpdates - Optional: Any additional data from questionnaire chat
   * @returns Hybrid OCR JSON payload ready for AI re-query
   */
  private createHybridOcrPayload(originalOcrData: any, sandboxPlan: any, chatUpdates?: any): any {
    const hybridPayload = _.cloneDeep(originalOcrData || {});

    // 1) Apply sandbox first so user manual edits always override original OCR (even when chat fails/empty)
    const sandboxMapped = this.mapSandboxPlanToOcrFormat(sandboxPlan);
    if (sandboxMapped && typeof sandboxMapped === 'object') {
      Object.keys(sandboxMapped).forEach(key => {
        const val = sandboxMapped[key];
        if (val !== undefined) {
          hybridPayload[key] = val;
        }
      });
    }

    // 2) Then apply chat updates (highest precedence)
    if (chatUpdates && typeof chatUpdates === 'object') {
      Object.keys(chatUpdates).forEach(key => {
        const val = chatUpdates[key];
        if (val !== null && val !== undefined) {
          hybridPayload[key] = val;
        }
      });
    }

    return hybridPayload;
  }

  /**
   * Maps sandbox plan fields to OCR JSON format.
   * Includes a key whenever the sandbox has the property (including empty string or 0)
   * so that user manual edits always override original OCR in createHybridOcrPayload.
   *
   * @param sandboxPlan - Current sandbox plan state (this.newTaxPlan)
   * @returns Mapped object with OCR-formatted fields
   */
  private mapSandboxPlanToOcrFormat(sandboxPlan: any): any {
    if (!sandboxPlan) return {};

    const mapped: any = {};

    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'totalTax')) {
      mapped.us_1040_total_tax = this.formatOcrNumber(sandboxPlan.totalTax);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'taxableIncome')) {
      mapped.us_1040_line_15_taxable_income = this.formatOcrNumber(sandboxPlan.taxableIncome);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'homeState')) {
      mapped.us_1040_state = sandboxPlan.homeState == null ? '' : String(sandboxPlan.homeState);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'filingStatus')) {
      const ocrFilingStatus = sandboxPlan.filingStatus
        ? this.denormalizeFilingStatus(sandboxPlan.filingStatus)
        : '';
      mapped.us_1040_filing_status = ocrFilingStatus || '';
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'taxYear')) {
      mapped.us_1040_year = sandboxPlan.taxYear != null ? String(sandboxPlan.taxYear) : '';
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'effectiveRate')) {
      mapped.effective_rate = this.formatOcrRate(sandboxPlan.effectiveRate);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'marginalRate')) {
      mapped.marginal_rate = this.formatOcrRate(sandboxPlan.marginalRate);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'capGainsRate')) {
      mapped.cap_gains_rate = this.formatOcrRate(sandboxPlan.capGainsRate);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'individualStateRate')) {
      mapped.individual_state_rate = this.formatOcrRate(sandboxPlan.individualStateRate);
    }
    if (Object.prototype.hasOwnProperty.call(sandboxPlan, 'corporateStateRate')) {
      mapped.corporate_state_rate = this.formatOcrRate(sandboxPlan.corporateStateRate);
    }

    return mapped;
  }

  /**
   * Formats numbers for OCR JSON payload
   * OCR format expects: string without commas, no currency symbols
   * Example: 12345.67 -> "12345.67"
   * 
   * @param value - Number or string value to format
   * @returns Formatted string for OCR JSON
   */
  private formatOcrNumber(value: number | string): string {
    if (value === null || value === undefined || value === '') return '';
    
    const numValue = typeof value === 'string' 
      ? parseFloat(value.toString().replace(/[,$]/g, ''))
      : value;
    
    if (isNaN(numValue)) return '';
    
    return numValue.toString();
  }

  /**
   * Formats tax rates for OCR JSON payload
   * 
   * Format: String representation of 0-100 range (percentage format)
   * Example: 15.5 → "15.5" (NOT "0.155" or "15.5%")
   * 
   * 
   * @param rate - Rate value (number or string)
   * @returns Formatted string for OCR JSON
   */
  private formatOcrRate(rate: number | string): string {
    if (rate === null || rate === undefined || rate === '') return '';
    
    const numRate = typeof rate === 'string' 
      ? parseFloat(rate.toString().replace(/[%]/g, ''))
      : rate;
    
    if (isNaN(numRate)) return '';
    
    return numRate.toString();
  }

  /**
   * Converts normalized filing status back to OCR format
   * Example: "Married Filing Jointly" -> "MFJ"
   * 
   * @param filingStatus - Normalized filing status from plan
   * @returns OCR format filing status code
   */
  private denormalizeFilingStatus(filingStatus: string): string {
    if (!filingStatus) return '';
    
    const statusMap: { [key: string]: string } = {
      'Single': 'S',
      'Married Filing Jointly': 'MFJ',
      'Married Filing Separately': 'MFS',
      'Head of Household': 'HH',
      'Qualifying Widow(er)': 'QW',
      'Qualifying Widow(er) with Dependent Child': 'QW',
      'MFJ': 'MFJ',
      'MFS': 'MFS',
      'HOH': 'HOH',
      'QSS': 'QSS'
    };
    
    return statusMap[filingStatus] || filingStatus;
  }

  populateStateRates() {
    const currentYear = new Date().getFullYear();
    const minYear = currentYear - 5;
    if (this.newTaxPlan.homeState && this.newTaxPlan.taxYear && Number(this.newTaxPlan.taxYear) >= minYear && Number(this.newTaxPlan.taxYear) <= currentYear) {
      let stateObj = _.find(this.states, (s) =>  s.short.toLowerCase() === this.newTaxPlan.homeState.toLowerCase());
      if (stateObj && stateObj.name) {
        this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(stateObj.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
        this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(stateObj.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
      }
    } else {
      this.newTaxPlan.individualStateRate = 0;
      this.newTaxPlan.corporateStateRate = 0;
    }
  }

  formatDraftStrategies(response) {
    const data: any[] = [];
    if (response && response.length > 0){
      _.each(response, (strategy) => {
        const suggestedObj = _.find(this.ocrSuggetions, {id: strategy.strategyId});
        if (suggestedObj) {
          suggestedObj['reviwedData'] = strategy;
          if (strategy.amount !== 0 && strategy.amount !== null && strategy.amount !== undefined) {
            suggestedObj['planAmount'] = strategy.amount;
          }
          data.push(suggestedObj);
        } else {
          const obj = _.find(this.allTaxStrategies, {id: strategy.strategyId});
          if (obj) {
            obj['reviwedData'] = strategy;
            obj['planAmount'] = strategy.amount ?? obj.planAmount;
            data.push(obj);
          }
        }
      });
      this.selectedStrategies = data;
      this.strategiesForReview = data;
    }
  }

  /**
   * Builds selectedStrategies (and strategiesForReview) from live plan strategies.
   * Used when Open in RAP loads a live plan: draft suggessions are empty, but planData
   * already has full strategies with amount. This preserves Est. Plan Amount in the UI.
   */
  formatPlanStrategiesForSelection(planStrategies: any[]) {
    if (!planStrategies || planStrategies.length === 0) {
      return;
    }
    const data: any[] = [];
    _.each(planStrategies, (strategy) => {
      const strategyId = strategy.strategyId || strategy.strategy_id;
      const obj = _.find(this.allTaxStrategies, { id: strategyId });
      if (obj) {
        const item = { ...obj, reviwedData: strategy, planAmount: strategy.amount ?? obj.planAmount };
        data.push(item);
      }
    });
    this.selectedStrategies = data;
    this.strategiesForReview = data;
  }

  async goToSelectedSection() {
    this.currentSection = this.tabToLand || 'clientInfo';
    switch (this.currentSection) {
      case 'planInfo':
        break;
      case 'strategiesInfo':
        if (this.isRapEditMode) {
          // ========================================
          // RAP SESSION: Always get AI suggestions with hybrid payload
          // ========================================
          let updatedOCRJson = null;
          if(this.isQuestionnarieInRapEnabled){
            // Try to get chat updates (may be null if never started)
            updatedOCRJson = await this.rapQuestionnaire.triggerBackgroundOCRChat("End Conversation", true) as any;
            
            this.newQuestionarieData = {
              ocrData: updatedOCRJson || '',
              chatId: this.rapSession?.payload?.chatId ?? this.chatId
            };
            this.updateQuestionarieData.emit(this.newQuestionarieData);
          }
          // Always call AI (with or without questionnaire) to get suggestions based on sandbox state
          this.executeStrategyRequery(updatedOCRJson || null, this.currentSection);
        }
        // ========================================
        // NORMAL FLOW: No special handling needed
        // ========================================
        // Development version is empty (just navigates)
        // No saves needed here - they happen in other navigation methods
        break;
      case 'review':
        this.strategiesForReview = this.selectedStrategies;
        break;
      case 'roiFee':
        break;
      case 'tasksInfo':
        break;
    }
    this.setSectionReviewedValuse(this.currentSection);
  }

  goToPreviousSection(section?) {
    if (this.currentSection === 'questionnaire') {
      trackPendoEvent('Discovery Exited', { from_sub_view: this.questionnaireTrack == 1 ? 'chat' : 'intro' });
    }
    this.currentSection = section;

    if(section === 'strategiesInfo') {
      this.secReview.reviewInfo = false;
      this.secReview.strategiesInfo = false;
      
      setTimeout(() => this.disposeTooltips());
      
    } else if(section === 'planInfo') {
      this.secReview.strategiesInfo = false;
      this.secReview.planInfo = false;
      this.populateStateRates();
      if (this.isRapEditMode) {
        // FIREWALL: Open-in-RAP mode - Just navigate, data in memory
      } else if (this.selectedStrategies.length > 0) {
        // Normal RAP: Save selected strategies
        this.saveSelectedStrategiesForPlan();
      }
      
    } else if(section === 'clientInfo') {
      this.secReview.planInfo = false;
      this.secReview.clientInfo = false;

      if (this.isRapEditMode) {
        // FIREWALL: Open-in-RAP mode - Skip updateClientStrategy()
      } else if(this.newTaxPlan.id) {
        // Normal RAP: Update client strategy
        this.updateClientStrategy();
      }
    } else if (section === 'review') {
      if (this.isRapEditMode && this.currentSection === 'roiFee') {
        this.syncRoiFeeToSandbox();
      }
      this.secReview.roiFeeInfo = false;
      this.secReview.reviewInfo = false;
      setTimeout(() => this.initTooltips());
    } else if (section === 'roiFee') {
      this.secReview.tasksList = false;
      this.secReview.roiFeeInfo = false;
    } else if (section === 'questionnaire'){
      this.secReview.strategiesInfo = false;
      this.secReview.questionnaire = false;
    }
  }

  async goToNextSection(section?) {
    switch (section) {
      case 'planInfo':
        this.newTaxPlan.clientId = this.effectiveClient?.id;
        this.newTaxPlan.userId = this.effectiveClient?.email;
        if (this.isRapEditMode) {
          // Validate required client fields (same as normal flow) before allowing Next
          if (!this.validateData()) return;
          // FIREWALL: Open-in-RAP mode - Update memory only
          this.syncPlanCoreToSandbox();
          this.currentSection = section;
          this.secReview.clientInfo = true;
        } else {
          // Normal RAP: Save to database (saveClient calls validateData internally)
          this.saveClient(null, section);
        }
        break;
      case 'questionnaire':
        this.secReview.planInfo = true;
        trackPendoEvent('Discovery Entered', { mode: this.isRapEditMode ? 'edit' : 'create' });
        // Navigate to questionnaire section
      if (this.isRapEditMode) {
        // Same validation as normal flow; data stays in sandbox
        if (!this.validateTaxplanData()) return;
        this.syncPlanCoreToSandbox();
        // First re-query: OCR edits only (no chat). Dirty guard skips if nothing changed.
        this.executeStrategyRequery(null, section);
        } else if(this.isReviewPlan || this.newTaxPlan.id) {
          if (this.validateTaxplanData()) {
            this.updateClientStrategy(null, section);
          }
        } else {
          if (this.validateTaxplanData()) {
            this.createTaxPlan(null, section);
          }
        }
        break;
     
        case 'strategiesInfo':
          if (this.isRapEditMode) {
            // Same validation as normal flow when coming from plan (plan data in sandbox)
            if (!this.validateTaxplanData()) return;
            // ALWAYS call AI with hybrid payload (user edits + questionnaire)
            let updatedOCRJson = null;
            if(this.isQuestionnarieInRapEnabled) {
              updatedOCRJson = await this.rapQuestionnaire.triggerBackgroundOCRChat("End Conversation", true) as any;
              trackPendoEvent('Discovery Completed', { mode: 'edit', ocr_returned: !!updatedOCRJson });
              this.newQuestionarieData = {
                ocrData: updatedOCRJson || '',
                chatId: this.rapSession?.payload?.chatId ?? this.chatId
              };
              this.updateQuestionarieData.emit(this.newQuestionarieData);
            }
            // ✅ ALWAYS call executeStrategyRequery (with or without questionnaire data)
            // This picks up user manual edits from sandbox (this.newTaxPlan)
            this.executeStrategyRequery(updatedOCRJson || null, 'strategiesInfo');
          } else {
            // ========================================
            // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
            // ========================================
            if (this.isQuestionnarieInRapEnabled && 
                this.questionnaireTrack == 1 && 
                this.chatMessages.length > 1) {
              
              const updatedOCRJson = await this.rapQuestionnaire?.triggerBackgroundOCRChat("End Conversation", true) as any;
              trackPendoEvent('Discovery Completed', { mode: 'create', ocr_returned: !!updatedOCRJson });
              this.newQuestionarieData = {
                ocrData: updatedOCRJson,
                chatId: this.chatId
              }
              this.updateQuestionarieData.emit(this.newQuestionarieData);
              
              if (updatedOCRJson) {
                this.loadingService.triggerLoadingEvent(true);
                this.taxPlanningService.getQuestionnarieOCRSuggestions(this.org, this.user, this.documentId, false, updatedOCRJson)
                  .subscribe({
                    next: (response) => {
                      if (response && response.suggestions && response.suggestions.length > 0) {
                        this.ocrSuggetions = this.formatedAiSuggestedStrategies(response.suggestions);
                        this.ocrSuggetions = _.orderBy(this.ocrSuggetions, 'planAmount', 'desc');
                      }
                      this.secReview.questionnaire = true;
                      this.currentSection = section;
                      this.chatId = response?.chat_id ?? 0;
                      this.chatMessages = [];
                      this.loadingService.triggerLoadingEvent(false);
                    },
                    // Without this branch the overlay stays on and the page
                    // freezes (868kuzmap). Move the user on with the
                    // suggestions we already hold.
                    error: (error) => {
                      console.error('Error fetching questionnaire OCR suggestions:', error);
                      this.toastService.pop(
                        TOAST_TYPE.error,
                        'Could not refresh AI suggestions. Showing the existing suggestions.'
                      );
                      this.secReview.questionnaire = true;
                      this.currentSection = section;
                      this.chatMessages = [];
                      this.loadingService.triggerLoadingEvent(false);
                    }
                  });
              } else {
                this.chatId = 0;
                this.chatMessages = [];
                this.secReview.questionnaire = true;
                this.currentSection = section;
              }
              
            } else {
              // No questionnaire - standard save logic
              if (this.isReviewPlan || this.newTaxPlan.id) {
                if (this.validateTaxplanData()) {
                  this.updateClientStrategy(null, section);
                }
              } else {
                if (this.validateTaxplanData()) {
                  this.createTaxPlan(null, section);
                }
              }
            }
          }
          break;
      case 'skip-questionnarie-strategiesInfo':
        trackPendoEvent('Discovery Skipped', { mode: this.isRapEditMode ? 'edit' : 'create' });
        if (this.isRapEditMode) {
          // RAP SESSION: Always get AI suggestions (even when skipped)
          // because we want AI to reflect sandbox changes
          this.executeStrategyRequery(null, 'strategiesInfo');
        } else {
          // NORMAL FLOW: Just navigate (match Development)
          this.secReview.questionnaire = true;
          this.currentSection = "strategiesInfo";
        }
        break;
      case 'review':
        this.strategiesForReview = this.selectedStrategies;
        
        if (this.isRapEditMode) {
          // FIREWALL: Open-in-RAP mode - Skip database save
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else {
          this.saveSelectedStrategiesForPlan(null, section);
        }
        break;

      case 'roiFee':
        if (this.isRapEditMode) {
          // Same validation as normal flow (review strategy years); data stays in sandbox
          if (!this.validateReviewedStrategiesData()) return;
          this.refreshSandboxCalculations();
          this.newTaxPlan['strategies'] = this.reviewedStrategies;
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else {
          // ========================================
          // NORMAL FLOW: Match Development exactly
          // ========================================
          const isDataValid = this.validateReviewedStrategiesData();
          if (isDataValid) {
            this.saveReviewStrategiesData('updateSavings');
            setTimeout(() => {
              this.newTaxPlan['strategies'] = this.reviewedStrategies;
              this.currentSection = section;
              this.setSectionReviewedValuse(this.currentSection);
            }, 1500);
          } else {
            setTimeout(() => this.disposeTooltips());
            setTimeout(() => this.initTooltips(), 5000);
          }
        }
        break;
      case 'tasksInfo':
        if (this.isRapEditMode) {
          // Same validation as normal flow (cost lines); no DB save
          const costLines = this.buildCostLinesForValidation();
          if (!costLines || !this.validateCostLines(costLines)) return;
          this.refreshSandboxCalculations();
          this.syncRoiFeeToSandbox();
          this.newTaxPlan['strategies'] = this.reviewedStrategies;
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else {
          const success = this.saveFeeForPlan();
          if (success === false) {
            return;
          }
          if (this.roiFeeInfo.draftRoiExist) {
            this.updateDraftDataForPlan()
          } else {
            this.saveDraftDataForPlan();
          }
          this.newTaxPlan['strategies'] = this.reviewedStrategies;
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        }
        break;
    }
  }

  // ************ ===========   core focus changes  ================== ********** //

  pushLabel(){
    if (!this.client.labels){
      this.client.labels = [];
    }
    if (this.tempLabelText){
      this.client.labels.push({
        label: this.tempLabelText
      });
      this.tempLabelText = '';
    }
  }

  removeLabel(index){
    this.client.labels.splice(index, 1);
  }

  setType($event, relatedPary){
    relatedPary.type = $event.name;
  }

  removeRelatedParty(index){
    const c = this.effectiveClient;
    if (c?.relatedParties) c.relatedParties.splice(index, 1);
  }

  addRelatedParty(){
    const c = this.effectiveClient;
    if (!c) return;
    if (!c.relatedParties) c.relatedParties = [];
    c.relatedParties.push({});
  }

  /**
   * Both Tax Summary inputs write straight through [(ngModel)] and recalculate on
   * blur, so the pre-edit figure is gone by then. Snapshot it on focus, since the
   * Total Tax delta needs the taxable income the user started from.
   */
  captureTaxSummaryBaseline(){
    this.taxableIncomeBeforeEdit = this.newTaxPlan.taxableIncome;
    this.totalTaxBeforeEdit = this.newTaxPlan.totalTax;
  }

  /** Canonical rule: a taxable income of zero or less has no effective rate to show. */
  showEffectiveRate(){
    return isEffectiveRateMeaningful(this.newTaxPlan?.taxableIncome);
  }

  calculateEffectiveRate(type?){
    if (this.rapSuggestionsReady) this.isRapSessionDirty = true;
    if (type && type === 'Taxable Income') {
      // Positive only: calculateMarginalRate() has no bracket that matches a
      // negative taxable income, so a business loss would leave the previous
      // positive rate on screen next to it.
      if (this.newTaxPlan.taxableIncome > 0 && !isNaN(this.newTaxPlan.taxableIncome)) {
        this.calculateMarginalRate();
        this.calculateCapGainsRate();

        // Anchored on the as-filed figure and moved at the marginal rate. See
        // utils-lib/tax-summary-recalc.ts for why it is not rederived outright.
        this.newTaxPlan.totalTax = recalculateTotalTax({
          previousTaxableIncome: (this.taxableIncomeBeforeEdit === null) ? this.newTaxPlan.taxableIncome : this.taxableIncomeBeforeEdit,
          newTaxableIncome: this.newTaxPlan.taxableIncome,
          currentTotalTax: this.newTaxPlan.totalTax,
          marginalRate: this.newTaxPlan.marginalRate,
          filingStatus: this.client?.filingStatus || this.newTaxPlan.filingStatus,
          totalTaxOverridden: this.newTaxPlan.totalTaxOverridden
        });
        const currentYear = new Date().getFullYear();
        const minYear = currentYear - 5;
        if (this.newTaxPlan.homeState && this.newTaxPlan.taxYear && Number(this.newTaxPlan.taxYear) >= minYear && Number(this.newTaxPlan.taxYear) <= currentYear) {
          let stateObj = _.find(this.states, {short: this.newTaxPlan.homeState});
          if (stateObj && stateObj.name) {
            this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(stateObj.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan);
            this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(stateObj.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan);
          }
        }
      }
    } else if (this.totalTaxBeforeEdit !== null && Number(this.newTaxPlan.totalTax) !== Number(this.totalTaxBeforeEdit)) {
      // Typed by hand, so it is never replaced by a bracket estimate later on.
      this.newTaxPlan.totalTaxOverridden = true;
    }

    // Last, so numerator and denominator are both post-edit. Recomputing this
    // first left the rate as old Total Tax over new Taxable Income.
    if (shouldRecalculateEffectiveRate(this.newTaxPlan.totalTax, this.newTaxPlan.taxableIncome)){
      this.newTaxPlan.effectiveRate = canonicalEffectiveRate(this.newTaxPlan.totalTax, this.newTaxPlan.taxableIncome);
      if (!(this.changeDetectorRef as ViewRef).destroyed) {
        this.changeDetectorRef.detectChanges();
      }
    }
    this.taxableIncomeBeforeEdit = null;
    this.totalTaxBeforeEdit = null;
  }

  calculateMarginalRate() {
    if (this.client && this.client.filingStatus) {
      const ti = Number(this.newTaxPlan.taxableIncome);
      if (isNaN(ti)) {
        return;
      }

      // Chart-based brackets
      // Single / MFS
      if (this.client.filingStatus === 'Single') {
        if (ti >= 0 && ti <= 12400) {
          this.newTaxPlan.marginalRate = 10;
        } else if (ti >= 12401 && ti <= 50400) {
          this.newTaxPlan.marginalRate = 12;
        } else if (ti >= 50401 && ti <= 105700) {
          this.newTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.newTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256225) {
          this.newTaxPlan.marginalRate = 32;
        } else if (ti >= 256226 && ti <= 640600) {
          this.newTaxPlan.marginalRate = 35;
        } else if (ti >= 640601) {
          this.newTaxPlan.marginalRate = 37;
        }
      }

      else if (this.client.filingStatus === 'MFS') {
        if (ti >= 0 && ti <= 12400) {
          this.newTaxPlan.marginalRate = 10;
        } else if (ti >= 12401 && ti <= 50400) {
          this.newTaxPlan.marginalRate = 12;
        } else if (ti >= 50401 && ti <= 105700) {
          this.newTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.newTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256225) {
          this.newTaxPlan.marginalRate = 32;
        } else if (ti >= 256226 && ti <= 384350) {
          this.newTaxPlan.marginalRate = 35;
        } else {
          this.newTaxPlan.marginalRate = 37;
        }
      }

      // MFJ
      else if (this.client.filingStatus === 'MFJ') {
        if (ti >= 0 && ti <= 24800) {
          this.newTaxPlan.marginalRate = 10;
        } else if (ti >= 24801 && ti <= 100800) {
          this.newTaxPlan.marginalRate = 12;
        } else if (ti >= 100801 && ti <= 211400) {
          this.newTaxPlan.marginalRate = 22;
        } else if (ti >= 211401 && ti <= 403550) {
          this.newTaxPlan.marginalRate = 24;
        } else if (ti >= 403551 && ti <= 512450) {
          this.newTaxPlan.marginalRate = 32;
        } else if (ti >= 512451 && ti <= 768700) {
          this.newTaxPlan.marginalRate = 35;
        } else if (ti >= 768701) {
          this.newTaxPlan.marginalRate = 37;
        }
      }

      // Head of Household
      else if (this.client.filingStatus === 'Head of Household') {
        if (ti >= 0 && ti <= 17700) {
          this.newTaxPlan.marginalRate = 10;
        } else if (ti >= 17701 && ti <= 67450) {
          this.newTaxPlan.marginalRate = 12;
        } else if (ti >= 67451 && ti <= 105700) {
          this.newTaxPlan.marginalRate = 22;
        } else if (ti >= 105701 && ti <= 201775) {
          this.newTaxPlan.marginalRate = 24;
        } else if (ti >= 201776 && ti <= 256200) {
          this.newTaxPlan.marginalRate = 32;
        } else if (ti >= 256201 && ti <= 640600) {
          this.newTaxPlan.marginalRate = 35;
        } else  if (ti >= 640601){
          this.newTaxPlan.marginalRate = 37;
        }
      }
       else if(this.client.filingStatus === 'Estate' || this.client.filingStatus === 'Trust') {
        if (ti >= 0 && ti <= 3300) {
          this.newTaxPlan.marginalRate = 10;
        } else if (ti >= 3301 && ti <= 11700) {
          this.newTaxPlan.marginalRate = 24;
        } else if (ti >= 11701 && ti <= 16000) {
          this.newTaxPlan.marginalRate = 35;
        } else {
          this.newTaxPlan.marginalRate = 37;
        }
      }
    }
  }

  calculateCapGainsRate() {
    // It will need to change this per tax year. Calculated based on cap gains table (https://taxfoundation.org/data/all/federal/2026-tax-brackets/)
    if (this.client && this.client.filingStatus) {
      const ti = Number(this.newTaxPlan.taxableIncome);
      if (isNaN(ti)) {
        return;
      }

      // Long-term capital gains brackets (chart-based)
      // Unmarried (Single)
      if (this.client.filingStatus === 'Single') {
        if (ti >= 0 && ti <= 49450) {
          this.newTaxPlan.capGainRate = 0;
        } else if (ti >= 49451 && ti <= 545500) {
          this.newTaxPlan.capGainRate = 15;
        } else {
          this.newTaxPlan.capGainRate = 20;
        }
      }
      else if(this.client.filingStatus === 'MFS'){
         if (ti >= 0 && ti <= 49450) {
          this.newTaxPlan.capGainRate = 0;
        } else if (ti >= 49451 && ti <= 306850) {
          this.newTaxPlan.capGainRate = 15;
        } else {
          this.newTaxPlan.capGainRate = 20;
        }
      }

      // Married Filing Jointly
      else if (this.client.filingStatus === 'MFJ') {
        if (ti >= 0 && ti <= 98900) {
          this.newTaxPlan.capGainRate = 0;
        } else if (ti >= 98901 && ti <= 613700) {
          this.newTaxPlan.capGainRate = 15;
        } else {
          this.newTaxPlan.capGainRate = 20;
        }
      }

      // Head of Household
      else if (this.client.filingStatus === 'Head of Household' || this.client.filingStatus === 'HOH') {
        if (ti >= 0 && ti <= 66200) {
          this.newTaxPlan.capGainRate = 0;
        } else if (ti >= 66201 && ti <= 579600) {
          this.newTaxPlan.capGainRate = 15;
        } else if (ti >= 579601) {
          this.newTaxPlan.capGainRate = 20;
        }
      }
      else if(this.client.filingStatus === 'Estate' || this.client.filingStatus === 'Trust') {
        if (ti >= 0 && ti <= 3300) {
          this.newTaxPlan.capGainRate = 0;
        } else if (ti >= 3301 && ti <= 16250) {
          this.newTaxPlan.capGainRate = 15;
        } else {
          this.newTaxPlan.capGainRate = 20;
        }
      }
    }
  }

  showRatesInfo(){
    window.open('https://taxfoundation.org/data/all/federal/2026-tax-brackets/');
  }

  onHomeStateSelect(state) {
    if (this.isRapEditMode) this.isRapSessionDirty = true;
    if (!_.isEmpty(state)) {
      this.newTaxPlan.homeState = state.short;
      const currentYear = new Date().getFullYear();
      const minYear = currentYear - 5;
      if (this.newTaxPlan.taxYear && Number(this.newTaxPlan.taxYear) >= minYear && Number(this.newTaxPlan.taxYear) <= currentYear) {
        this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(state.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
        this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(state.name, this.client.filingStatus, this.newTaxPlan.taxableIncome, this.newTaxPlan.taxYear);
      }
    }else{
      this.newTaxPlan.homeState = '';
    }
  }

  showStateRatesInfo(type){
    if (type == 'individual') {
      window.open('https://taxfoundation.org/publications/state-individual-income-tax-rates-and-brackets/');
    } else if (type == 'corporate') {
      window.open('https://taxfoundation.org/publications/state-corporate-income-tax-rates-and-brackets/');
    }
  }

  removeCustomTaxRate(index){
    this.newTaxPlan.customTaxRates.splice(index, 1);
  }

  addCustomTaxRate(){
    this.newTaxPlan.customTaxRates.push({});
    setTimeout(() => {
      this.scrollToBottom();
    }, 100);

  }

  closeCreatePopup() {
    if (this.isRapEditMode) this.rapClient = null;
    this.onCancelCreationOfStrategy.emit();
  }

  // upload create plan changes start

  setSelectedItems(data, type?) {
    this.selectedStrategies = data.list;
    if (data.action === 'removed') {
      _.remove(this.reviewedStrategies, { strategyId: data.item.id });
    }
    if (type) {
      this.strategiesForReview = this.selectedStrategies;
      this.saveSelectedStrategiesForPlan('draft');
    }
  }

  getClient(){
    this.taxPlanningService.getClient(this.org, this.user, this.clientId, false)
      .subscribe(response => {
        this.client = response;
        this.newTaxPlan.clientId = this.client.id;
        this.newTaxPlan.userId = this.client.email;
        this.newTaxPlan.taxYear = this.client.defaultYear || new Date().getFullYear();
        if (!this.isRapEditMode) {
          this.newTaxPlan.name = (this.planName) ? this.planName : '';
        }
        // Load full plan data when reopening any draft (both RAP and normal mode)
        if (this.isReviewPlan && this.draftPlanId) {
          this.getPlanData();
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get client data');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get client data');
        }
      });
  }

  getPlanData() {
    this.taxPlanningService.getTaxPlanForClient(this.org, this.user, this.draftPlanId, null, null, null, false)
      .subscribe(response => {
        this.newTaxPlan = response;
        if (this.isRapEditMode) {
          this.newTaxPlan.name = response.name || this.rapSourcePlanName;
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get plan data');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get plan data');
        }
      });
  }

  getDraftSelectedStrategies(refreshY1Savings?) {
    const data: any[] = [];
    this.loadingService.triggerLoadingEvent(true);
    
    this.taxPlanningService.draftSelectedStrategies(this.org, this.user, this.draftPlanId || this.newTaxPlan.id)
      .subscribe({
        next: (response) => {
          if (refreshY1Savings) {
            // ✅ Simple refresh (same for all)
            this.year1Savings = response.year1Savings || 0;
            this.year2Savings = response.year2Savings || 0;
            this.loadingService.triggerLoadingEvent(false);
          } else {
            // Set year savings (common to all paths)
            this.year1Savings = response.year1Savings || 0;
            this.year2Savings = response.year2Savings || 0;
            
            // ========================================
            // FORK: RAP SESSION vs NORMAL FLOW
            // ========================================
            
            if (this.forceRapMode && this.isReviewPlan && this.draftPlanId) {
              // ====================================================
              // RAP SESSION FLOW ONLY
              // ====================================================
              // ALL the complexity goes here:
              // - Extra getTaxPlanForClient() API call
              // - Normalize documentId
              // - Format strategies
              // - Set reviewedStrategies
              // - Fetch OCR data
              // - Initialize RAP session
              // - Setup sections
              // - etc.
              
              this.taxPlanningService.getTaxPlanForClient(this.org, this.user, this.draftPlanId, null, null, null, false)
                .subscribe({
                  next: (planData) => {
                    const draftSuggessions = response.suggessions || [];
                    const planStrategies = planData.strategies || [];
                    const useLivePlanStrategies = draftSuggessions.length === 0 && planStrategies.length > 0;

                    if (useLivePlanStrategies) {
                      this.reviewedStrategies = planStrategies;
                      this.formatPlanStrategiesForSelection(planStrategies);
                    } else {
                      this.formatDraftStrategies(draftSuggessions);
                      this.reviewedStrategies = draftSuggessions;
                    }

                    this.documentId = planData.documentId || planData.document_id || null;
                    
                    if (this.documentId) {
                      this.newTaxPlan.documentId = this.documentId;
                    }
                    
                    const clientIdForOcr = this.clientId || planData.clientId || planData.client_id;
                    
                    if (this.documentId && clientIdForOcr) {
                      this.taxPlanningService.getOCRSuggestions(this.org, this.user, clientIdForOcr, this.documentId)
                        .subscribe({
                          next: (ocrResponse) => {
                            if (ocrResponse && ocrResponse.ocrdata) {
                              this.formatOcrData(ocrResponse);
                            }
                            const strategiesForSession = useLivePlanStrategies ? planStrategies : (this.selectedStrategies || []);
                            const fullPlanData = {
                              ...planData,
                              strategies: strategiesForSession,
                              tasks: planData.tasks || [],
                              customTaxRates: planData.customTaxRates || [],
                              year1Savings: this.year1Savings,
                              year2Savings: this.year2Savings,
                              chatId: ocrResponse?.chat_id || undefined
                            };
                            this.initializeRapEditSession(fullPlanData);

                            this.dataLoaded = true;
                            this.loadingService.triggerLoadingEvent(false);

                            // Guard: getRequiredSuggestionsData runs in parallel and completes first
                            // (parallel forkJoin vs. 3 sequential API calls here). If it already
                            // positioned the user, don't reset secReview flags, currentSection, or
                            // re-navigate — doing so would override the user's current position.
                            if (!this.rapSuggestionsReady) {
                              this.currentSection = 'clientInfo';
                              this.secReview.clientInfo = false;
                              this.secReview.planInfo = true;
                              this.secReview.strategiesInfo = true;
                              setTimeout(() => {
                                this.goToSelectedSection();
                              }, 100);
                            }
                          },
                          error: (error) => {
                            // Still initialize RAP session even if OCR fetch fails
                            const strategiesForSession = useLivePlanStrategies ? planStrategies : (this.selectedStrategies || []);
                            const fullPlanData = {
                              ...planData,
                              strategies: strategiesForSession,
                              tasks: planData.tasks || [],
                              customTaxRates: planData.customTaxRates || [],
                              year1Savings: this.year1Savings,
                              year2Savings: this.year2Savings
                            };
                            this.initializeRapEditSession(fullPlanData);

                            this.dataLoaded = true;
                            this.loadingService.triggerLoadingEvent(false);

                            if (!this.rapSuggestionsReady) {
                              this.currentSection = 'clientInfo';
                              this.secReview.clientInfo = false;
                              this.secReview.planInfo = true;
                              this.secReview.strategiesInfo = true;
                              setTimeout(() => {
                                this.goToSelectedSection();
                              }, 100);
                            }
                          }
                        });
                    } else {
                      // No documentId - still initialize RAP session
                      const strategiesForSession = useLivePlanStrategies ? planStrategies : (this.selectedStrategies || []);
                      const fullPlanData = {
                        ...planData,
                        strategies: strategiesForSession,
                        tasks: planData.tasks || [],
                        customTaxRates: planData.customTaxRates || [],
                        year1Savings: this.year1Savings,
                        year2Savings: this.year2Savings
                      };
                      this.initializeRapEditSession(fullPlanData);
                      this.loadingService.triggerLoadingEvent(false);
                      this.goToSelectedSection();
                    }
                  },
                  error: (error) => {
                    console.error('Error loading plan data for RAP session:', error);
                    this.loadingService.triggerLoadingEvent(false);
                    this.toastService.pop(TOAST_TYPE.error, 'Failed to load plan data');
                  }
                });
                
            } else {
              // ====================================================
              // NORMAL FLOW (EXACT COPY OF DEVELOPMENT)
              // ====================================================
              this.formatDraftStrategies(response.suggessions || []);
              this.loadingService.triggerLoadingEvent(false);
              this.goToSelectedSection();
            }
          }
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try {
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to get draft strategies');
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to get draft strategies');
          }
        }
      });
  }

  setReviewedStrategiesList(data) {
    this.reviewedStrategies = data.list;
    
    // This provides "live" savings updates in the Review milestone UI
    if (this.isRapEditMode) {
      this.refreshSandboxCalculations();
    }
  }

  async moveToSection(sectionName) {
    if(sectionName == 'planInfo'){
      this.populateStateRates();
    }
    switch (this.currentSection) {
      case 'clientInfo':
        this.saveClient(null, sectionName, true);
        break;
      case 'planInfo':
        if (this.isRapEditMode) {
          // Same validation as normal flow before allowing navigation (no API call)
          if (!this.validateTaxplanData()) return;
          this.currentSection = sectionName;
          this.setSectionReviewedValuse(sectionName);
        } else if (this.isReviewPlan || this.newTaxPlan.id) {
          if (this.validateTaxplanData()) {
            this.updateClientStrategy(null, sectionName, true);
          }
        } else {
          if (this.validateTaxplanData()) {
            this.createTaxPlan(null, sectionName, true);
          }
        }
        break;
       case 'questionnaire':
        this.setSectionReviewedValuse(sectionName);
        this.currentSection = sectionName;
        break;
      case 'strategiesInfo':
        if (this.isRapEditMode) {
          // ========================================
          // RAP SESSION FLOW (Sandbox Mode)
          // ========================================
          
          // Step 1: Try to get questionnaire updates (may be null if not used)
          let updatedOCRJson = null;
          if (this.isQuestionnarieInRapEnabled) {
            updatedOCRJson = await this.rapQuestionnaire.triggerBackgroundOCRChat("End Conversation", true) as any;
            this.newQuestionarieData = {
              ocrData: updatedOCRJson || '{}',
              chatId: this.chatId
            };
            this.updateQuestionarieData.emit(this.newQuestionarieData);
          }
          
          // Step 2: ALWAYS call AI suggestions API with hybrid payload
          // This includes:
          // - User-edited OCR data from sandbox (this.newTaxPlan current state)
          // - Questionnaire results (if any)
          // - Even if nothing changed, we want AI to re-evaluate based on sandbox state
          this.executeStrategyRequery(updatedOCRJson || null, sectionName);
          
          // Note: No database saves - everything stays in sandbox until final commit
          
        } else {
          // ========================================
          // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
          // ========================================
          if (sectionName === 'review') {
            if (this.selectedStrategies && this.selectedStrategies.length > 0) {
              this.strategiesForReview = this.selectedStrategies;
              this.saveSelectedStrategiesForPlan(null, sectionName, true);
            } else {
              this.toastService.pop(TOAST_TYPE.warning, 'Strategies must be required for review');
            }
          } else {
            this.currentSection = sectionName;
            this.setSectionReviewedValuse(sectionName);
          }
        }
        break;
      case 'review':
        if (sectionName === 'roiFee') {
          if (this.reviewedStrategies && this.reviewedStrategies.length > 0) {
            if (this.isRapEditMode) {
              // RAP Edit: Same validation as normal flow (year format/range) before allowing navigation
              if (!this.validateReviewedStrategiesData()) return;
              this.refreshSandboxCalculations();
              this.newTaxPlan['strategies'] = this.reviewedStrategies;
              this.currentSection = sectionName;
              this.setSectionReviewedValuse(sectionName);
            } else {
              // Normal RAP: Save reviewed strategies with delay
              this.saveReviewStrategiesData('updateSavings');
              setTimeout(() => {
                this.newTaxPlan['strategies'] = this.reviewedStrategies;
                this.currentSection = sectionName;
                this.setSectionReviewedValuse(sectionName);
              }, 2000);
            }
          } else {
            this.toastService.pop(TOAST_TYPE.warning, 'Selected strategies should be reviewed.');
          }
        } else {
          this.currentSection = sectionName;
          this.setSectionReviewedValuse(sectionName);
        }
        break;
        case 'roiFee':
          if (this.isRapEditMode) {
            // ========================================
            // RAP SESSION FLOW (Sandbox)
            // ========================================
            // Sync ROI to sandbox while still on ROI tab (roiFeeInfo ViewChild in DOM)
            // so edits are captured before *ngIf destroys the component on section change
            if (sectionName !== 'roiFee') {
              this.syncRoiFeeToSandbox();
            }
            // RAP edit: Same validation as normal flow (cost lines) before allowing navigation to Tasks
            if (sectionName === 'tasksInfo') {
              const costLines = this.buildCostLinesForValidation();
              if (!costLines || !this.validateCostLines(costLines)) return;
            }
            // No auto-saves - just navigate (user will commit manually in tasksInfo)
            this.currentSection = sectionName;
            this.setSectionReviewedValuse(sectionName);
            setTimeout(() => this.initTooltips());
          } else {
            // ========================================
            // NORMAL FLOW
            // ========================================
            if (sectionName === 'tasksInfo') {
              this.saveFeeForPlan();
              if (this.roiFeeInfo.draftRoiExist) {
                this.updateDraftDataForPlan()
              } else {
                this.saveDraftDataForPlan();
              }
            }
            this.currentSection = sectionName;
            this.setSectionReviewedValuse(sectionName);
            setTimeout(() => this.initTooltips());
          }
          break;
        
        case 'tasksInfo':
          if (this.isRapEditMode) {
            // ========================================
            // RAP SESSION FLOW (Sandbox)
            // ========================================
            // Just navigate to tasks section
            // User will explicitly click "Commit" or "Save" button here
            // That button will call the final commit method
            this.currentSection = sectionName;
            this.setSectionReviewedValuse(sectionName);
          } else {
            // ========================================
            // NORMAL FLOW
            // ========================================
            this.saveFeeForPlan();
            if (this.roiFeeInfo.draftRoiExist) {
              this.updateDraftDataForPlan()
            } else {
              this.saveDraftDataForPlan();
            }
            this.currentSection = sectionName;
            this.setSectionReviewedValuse(sectionName);
          }
          break;
    }

  }

  saveClient(type?, section?, selected?){
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode (no API call; same client validation as normal flow)
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // Same validation as normal flow before allowing navigation (Next or progress bar)
      if (section && !this.validateData()) return;
      if (section) {
        this.currentSection = section;
        this.secReview.clientInfo = true;
      }
      return;
    }
    
    // Normal mode: Proceed with saving client
    if (this.validateData()){
      this.loadingService.triggerLoadingEvent(true);
      this.taxPlanningService.updateClient(this.org, this.user, this.client.id, this.client).subscribe(response => {
        if(response && response.relatedParties){
           this.client.relatedParties = response.relatedParties;
        }
        this.loadingService.triggerLoadingEvent(false);
        this.taxStrategyServices.clearFirmLabelsData();
        this.taxPlanningService.clearClientData();
        this.populateStateRates();
        this.calculateMarginalRate();
        this.calculateCapGainsRate();
        this.toastService.pop(TOAST_TYPE.success, 'Client updated successfully');
        if (section) {
          if (selected) {
            this.validateRoutePath(section);
          } else {
            this.currentSection = section;
            this.secReview.clientInfo = true;
          }
        }
        if (type && type === 'draft') {
          this.draftSaved = true;
          setTimeout(() => {
            this.draftSaved = false;
          }, 5000);
        }
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update client');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update client');
        }
      });
    }
  }

  setSectionReviewedValuse(sectionName) {
    if(sectionName === 'planInfo') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = false;
      this.secReview.questionnaire = false;
      this.secReview.strategiesInfo = false;
      this.secReview.reviewInfo = false;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    } else if(sectionName === 'strategiesInfo') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = true;
      this.secReview.questionnaire = true;
      this.secReview.strategiesInfo = false;
      this.secReview.reviewInfo = false;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    }else if(sectionName === 'questionnaire') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = true;
      this.secReview.questionnaire = false;
      this.secReview.strategiesInfo = false;
      this.secReview.reviewInfo = false;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    } else if(sectionName === 'review') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = true;
      this.secReview.questionnaire = true;
      this.secReview.strategiesInfo = true;
      this.secReview.reviewInfo = false;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    }else if(sectionName === 'roiFee') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = true;
      this.secReview.questionnaire = true;
      this.secReview.strategiesInfo = true;
      this.secReview.reviewInfo = true;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    } else if(sectionName === 'tasksInfo') {
      this.secReview.clientInfo = true;
      this.secReview.planInfo = true;
      this.secReview.questionnaire = true;
      this.secReview.strategiesInfo = true;
      this.secReview.reviewInfo = true;
      this.secReview.roiFeeInfo = true;
      this.secReview.tasksList = false;
    } else if(sectionName === 'clientInfo') {
      this.secReview.clientInfo = false;
      this.secReview.planInfo = false;
      this.secReview.questionnaire = false;
      this.secReview.strategiesInfo = false;
      this.secReview.reviewInfo = false;
      this.secReview.roiFeeInfo = false;
      this.secReview.tasksList = false;
    }
  }

  validateData(){
    const c = this.effectiveClient;
    if (!c) return false;
    if (!c.firstName || (typeof c.firstName === 'string' && !c.firstName.trim())){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter First Name');
      return false;
    }
    if (!c.lastName || (typeof c.lastName === 'string' && !c.lastName.trim())){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Last Name');
      return false;
    }
    if (c.email && !isValidEmail(c.email)){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid email');
      return false;
    }
    return true;
  }

  /** Used to disable Next on client step when required fields are invalid (no toast). */
  isClientInfoValid(): boolean {
    const c = this.effectiveClient;
    if (!c) return false;
    if (!c.firstName || (typeof c.firstName === 'string' && !c.firstName.trim())) return false;
    if (!c.lastName || (typeof c.lastName === 'string' && !c.lastName.trim())) return false;
    if (c.email && !isValidEmail(c.email)) return false;
    return true;
  }

  createTaxPlan(type?, section?, selected?) {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // Handle UI navigation if section specified
      if (section) {
        this.currentSection = section;
        this.setSectionReviewedValuse(section);
      }
      return;
    }
    
    // Normal mode: Proceed with creating tax plan
    this.normalizeInvestmentOverrideFlag();
    this.newTaxPlan.id = '';
    this.newTaxPlan.type = 'corefocus';
    this.newTaxPlan.strategyTypes = [{
      strategies: []
    }];
    this.newTaxPlan['documentId'] = this.documentId;
    this.getFormattedCustomRates();
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.createTaxPlanForClient(this.org, this.user, this.newTaxPlan).subscribe({
      next: (response) => {
        this.loadingService.triggerLoadingEvent(false);
        if(this.chatId != response.chatId && this.isQuestionnarieInRapEnabled)
        {
          this.chatId = response.chatId
          this.getOCRSuggestions();
        }
        this.toastService.pop(TOAST_TYPE.success, 'Tax Plan created successfully');
        if (section) {
          if (selected) {
            this.validateRoutePath(section);
          } else {
            this.currentSection = section;
            this.setSectionReviewedValuse(section);
          }
        }
        this.newTaxPlan = response;

        if (type && type === 'draft') {
          this.draftSaved = true;
          setTimeout(() => {
            this.draftSaved = false;
          }, 5000);
        }
      },
      error: (error) => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to create plan');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create plan');
        }
      }
    });
  }

  getFormattedCustomRates() {
    // CRITICAL: Do NOT auto-generate custom rates in RAP mode
    // In RAP mode, we only use data from the source plan (never make things up)
    if (this.isRapEditMode) {
      return;
    }

    // Normal mode: Auto-generate state rate entries from the simple input fields
    if (this.newTaxPlan.homeState) {
      const indiStateTaxRate = {name : 'Ind State Rate', rate: this.newTaxPlan.individualStateRate, formula: "{\"actualValue\":\"\",\"displayValue\":\"\",\"displayValuesArray\":[],\"actualValuesArray\":[],\"type\":\"individual\"}"};
      const indiCorporateTaxRate = {name : 'Corp State Rate', rate: this.newTaxPlan.corporateStateRate, formula: "{\"actualValue\":\"\",\"displayValue\":\"\",\"displayValuesArray\":[],\"actualValuesArray\":[],\"type\":\"corporate\"}"};

      indiStateTaxRate.name = this.newTaxPlan.homeState + ' ' + indiStateTaxRate.name;
      indiCorporateTaxRate.name = this.newTaxPlan.homeState + ' ' + indiCorporateTaxRate.name;

      this.newTaxPlan.customTaxRates.push(indiStateTaxRate);
      this.newTaxPlan.customTaxRates.push(indiCorporateTaxRate);
      this.newTaxPlan.customTaxRates = _.uniqBy(this.newTaxPlan.customTaxRates, 'name');
    }
  }

  /**
   * Returns true if the value is a valid number for plan fields (Total Tax, Taxable Income, rates).
   * Used in RAP edit so we mirror backend type validation in the frontend (no API until commit).
   */
  private isValidPlanNumericValue(val: any): boolean {
    if (val == null || val === '') return false;
    const n = Number(val);
    return typeof n === 'number' && !Number.isNaN(n) && Number.isFinite(n);
  }

  validateTaxplanData(){
    const base = this;
    if (!this.newTaxPlan.clientId){
      this.toastService.pop(TOAST_TYPE.error, 'Please select client');
      return false;
    }
    if (!this.newTaxPlan.name){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Plan name');
      return false;
    }
    // This check is new and only applies to RAP edit. 
    if (this.newTaxPlan.totalTax == null || this.newTaxPlan.totalTax === ''){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Total Tax');
      return false;
    }
    if (this.newTaxPlan.taxableIncome == null || this.newTaxPlan.taxableIncome === ''){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Taxable Income');
      return false;
    }
    if (!this.newTaxPlan.marginalRate){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Marginal Rate');
      return false;
    }
    if (typeof this.newTaxPlan.capGainRate === "undefined"){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Cap Gain Rate');
      return false;
    }
    if (!this.newTaxPlan.ccropFlatRate){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter CCorp Flat Rate');
      return false;
    }
    if (!this.newTaxPlan.taxYear){
      this.toastService.pop(TOAST_TYPE.error, 'Please enter Tax Plan year');
      return false;
    }
    const isMatch = this.states.some(state => state.short === this.newTaxPlan.homeState);
    if (!this.newTaxPlan.homeState || !isMatch || 
      this.newTaxPlan.homeState === 0 ||
      this.newTaxPlan.homeState === '0' ||
      this.newTaxPlan.homeState === undefined||
      this.newTaxPlan.homeState === '' ||
      this.newTaxPlan.homestate === null
    ) {
      this.toastService.pop(TOAST_TYPE.error, 'Please select state');
      return false;
    }
    // RAP edit: no API until commit, so we must validate numeric fields here (same as backend would reject).
    if (this.isRapEditMode) {
      if (!this.isValidPlanNumericValue(this.newTaxPlan.totalTax)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for Total Tax');
        return false;
      }
      if (!this.isValidPlanNumericValue(this.newTaxPlan.taxableIncome)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for Taxable Income');
        return false;
      }
      if (!this.isValidPlanNumericValue(this.newTaxPlan.marginalRate)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for Marginal Rate');
        return false;
      }
      if (!this.isValidPlanNumericValue(this.newTaxPlan.capGainRate)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for Cap Gains Rate');
        return false;
      }
      if (!this.isValidPlanNumericValue(this.newTaxPlan.ccropFlatRate)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for C Corp Flat Rate');
        return false;
      }
      if (this.newTaxPlan.effectiveRate != null && this.newTaxPlan.effectiveRate !== '' && !this.isValidPlanNumericValue(this.newTaxPlan.effectiveRate)) {
        this.toastService.pop(TOAST_TYPE.error, 'Please enter a valid number for Effective Rate');
        return false;
      }
    }
    // Both fields are optional, but a malformed value (e.g. "a%") must never reach
    // the backend - see isValidStateRateValue(). Defense-in-depth alongside the
    // isPlanInfoValid()/isPlanInfoValidExceptName() checks that disable Next.
    if (!this.isValidStateRateValue(this.newTaxPlan.individualStateRate) ||
        !this.isValidStateRateValue(this.newTaxPlan.corporateStateRate)) {
      this.toastService.pop(TOAST_TYPE.error, 'Invalid input - please enter proper numeric value to proceed');
      return false;
    }
    return true;
  }

  /**
   * Used to enable Next on Tax Summary in RAP edit when all fields except Plan Name are valid.
   * In RAP edit we do not prefill Plan Name; Next is active and validateTaxplanData() shows a red toast if user clicks Next without entering name.
   */
  isPlanInfoNextEnabled(): boolean {
    if (this.isRapEditMode) {
      return this.isPlanInfoValidExceptName();
    }
    return this.isPlanInfoValid();
  }

  /** Same as isPlanInfoValid() but omits the Plan Name check. Used for RAP edit Tax Summary Next button. */
  isPlanInfoValidExceptName(): boolean {
    if (!this.newTaxPlan) return false;
    if (!this.newTaxPlan.clientId) return false;
    // Intentionally skip: if (!this.newTaxPlan.name || ...) return false;
    if (this.newTaxPlan.totalTax == null || this.newTaxPlan.totalTax === '') return false;
    if (this.newTaxPlan.taxableIncome == null || this.newTaxPlan.taxableIncome === '') return false;
    if (this.newTaxPlan.marginalRate == null || this.newTaxPlan.marginalRate === undefined || this.newTaxPlan.marginalRate === '') return false;
    if (typeof this.newTaxPlan.capGainRate === 'undefined') return false;
    if (this.newTaxPlan.ccropFlatRate == null || this.newTaxPlan.ccropFlatRate === undefined || this.newTaxPlan.ccropFlatRate === '') return false;
    if (!this.newTaxPlan.taxYear) return false;
    if (!this.states?.length) return false;
    const isMatch = this.states.some((state: any) => state.short === this.newTaxPlan.homeState);
    if (!this.newTaxPlan.homeState || !isMatch ||
      this.newTaxPlan.homeState === 0 ||
      this.newTaxPlan.homeState === '0' ||
      this.newTaxPlan.homeState === '' ||
      this.newTaxPlan.homestate === null
    ) return false;
    if (this.isRapEditMode) {
      if (!this.isValidPlanNumericValue(this.newTaxPlan.totalTax)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.taxableIncome)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.marginalRate)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.capGainRate)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.ccropFlatRate)) return false;
      if (this.newTaxPlan.effectiveRate != null && this.newTaxPlan.effectiveRate !== '' && !this.isValidPlanNumericValue(this.newTaxPlan.effectiveRate)) return false;
    }
    // Both fields are optional, but a malformed value (e.g. "a%") must never reach
    // the backend - it has no API call to reject it before commit, unlike the fields above.
    if (!this.isValidStateRateValue(this.newTaxPlan.individualStateRate)) return false;
    if (!this.isValidStateRateValue(this.newTaxPlan.corporateStateRate)) return false;
    return true;
  }

  /** Used to disable Next on Tax Summary when required plan fields are invalid (no toast). Same rules as validateTaxplanData(). */
  isPlanInfoValid(): boolean {
    if (!this.newTaxPlan) return false;
    if (!this.newTaxPlan.clientId) return false;
    if (!this.newTaxPlan.name || (typeof this.newTaxPlan.name === 'string' && !this.newTaxPlan.name.trim())) return false;
    // Added this check because of RAP edit.
    if (this.newTaxPlan.totalTax == null || this.newTaxPlan.totalTax === '') return false;
    if (this.newTaxPlan.taxableIncome == null || this.newTaxPlan.taxableIncome === '') return false;
    if (this.newTaxPlan.marginalRate == null || this.newTaxPlan.marginalRate === undefined || this.newTaxPlan.marginalRate === '') return false;
    if (typeof this.newTaxPlan.capGainRate === 'undefined') return false;
    if (this.newTaxPlan.ccropFlatRate == null || this.newTaxPlan.ccropFlatRate === undefined || this.newTaxPlan.ccropFlatRate === '') return false;
    if (!this.newTaxPlan.taxYear) return false;
    if (!this.states?.length) return false;
    const isMatch = this.states.some((state: any) => state.short === this.newTaxPlan.homeState);
    if (!this.newTaxPlan.homeState || !isMatch ||
      this.newTaxPlan.homeState === 0 ||
      this.newTaxPlan.homeState === '0' ||
      this.newTaxPlan.homeState === '' ||
      this.newTaxPlan.homestate === null
    ) return false;
    // RAP edit: require valid numbers so Next is disabled when backend would reject (no API until commit).
    if (this.isRapEditMode) {
      if (!this.isValidPlanNumericValue(this.newTaxPlan.totalTax)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.taxableIncome)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.marginalRate)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.capGainRate)) return false;
      if (!this.isValidPlanNumericValue(this.newTaxPlan.ccropFlatRate)) return false;
      if (this.newTaxPlan.effectiveRate != null && this.newTaxPlan.effectiveRate !== '' && !this.isValidPlanNumericValue(this.newTaxPlan.effectiveRate)) return false;
    }
    // Both fields are optional, but a malformed value (e.g. "a%") must never reach
    // the backend - see isValidStateRateValue().
    if (!this.isValidStateRateValue(this.newTaxPlan.individualStateRate)) return false;
    if (!this.isValidStateRateValue(this.newTaxPlan.corporateStateRate)) return false;
    return true;
  }

  updateClientStrategy(type?, section?, selected?){
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode and not doing final save
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // Handle UI navigation if section specified
      if (section) {
        this.currentSection = section;
        this.setSectionReviewedValuse(section);
      }
      return;
    }
    
    // Normal mode: Proceed with database update
    this.normalizeInvestmentOverrideFlag();
    this.setStateCustomRateValues();
    this.stringifyCustomRateFormulas();
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateTaxPlanForClient(this.org, this.user, this.newTaxPlan.id, this.newTaxPlan)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);

          if(this.isQuestionnarieInRapEnabled)
            {
              this.chatId = response.chatId
              this.getOCRSuggestions();
            }
          this.toastService.pop(TOAST_TYPE.success, 'Tax Plan Updated Successfully');
          this.newTaxPlan = response;
          // Sync backend-assigned plan line IDs into reviewedStrategies so subsequent
          // commits UPDATE existing rows (ON DUPLICATE KEY UPDATE) instead of INSERTing
          // duplicates (which happens when id is blank → backend generates new UUID).
          if (response && response.strategies && this.reviewedStrategies && this.reviewedStrategies.length > 0) {
            _.each(response.strategies, (line) => {
              const reviewed = _.find(this.reviewedStrategies, {strategyId: line.strategyId});
              if (reviewed && line.id) {
                reviewed.id = line.id;
              }
            });
          }
          if (section) {
            if (selected) {
              this.validateRoutePath(section);
            } else {
              this.currentSection = section;
              this.setSectionReviewedValuse(section);
            }
          }
          if (type && type === 'addStrategiesToPlan') {
            if (this.tasksList && this.tasksList.length > 0) {
              this.createTasksAndPlan();
            } else {
              this.onCancelCreationOfStrategy.emit({fromTasksSection: true, plan: this.newTaxPlan});
            }
          }

          if (type && type === 'draft') {
            this.draftSaved = true;
            setTimeout(() => {
              this.draftSaved = false;
            }, 5000);
          }

        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try{
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update tax plan');
          } catch (e){
            this.toastService.pop(TOAST_TYPE.error, 'Failed to update tax plan');
          }
        }
      });
  }

  setStateCustomRateValues() {
    if (this.newTaxPlan.id && this.newTaxPlan.homeState) {
      if (this.newTaxPlan.customTaxRates && this.newTaxPlan.customTaxRates.length > 0) {
        // COMMON: Update existing custom rates (same for both RAP and normal flow)
        _.each(this.newTaxPlan.customTaxRates, (customRate) => {
          let obj = _.cloneDeep(customRate);
          if (obj && obj.formula) {
            try {
              let formula = (_.isString(obj.formula)) ? JSON.parse(obj.formula) : obj.formula;
              if (formula && formula.type && formula.type === 'corporate') {
                customRate.name = this.newTaxPlan.homeState + ' Corp State Rate';
                customRate.rate = (this.newTaxPlan.corporateStateRate) ?  this.newTaxPlan.corporateStateRate : customRate.rate;
              } else if (formula && formula.type && formula.type === 'individual') {
                customRate.name = this.newTaxPlan.homeState + ' Ind State Rate';
                customRate.rate = (this.newTaxPlan.individualStateRate) ?  this.newTaxPlan.individualStateRate : customRate.rate;
              }
            } catch (e){}
          }
        });
      } else if (this.isRapEditMode) {
        // ========================================
        // RAP SESSION: Don't auto-generate rates
        // ========================================
        // CRITICAL: If source plan has no custom rates, keep it empty (don't make up data)
        // Custom rates will only be added if user explicitly edits the plan and adds them
        // This preserves the principle: RAP mode never auto-generates data from source
        this.newTaxPlan.customTaxRates = [];
      } else {
        // ========================================
        // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
        // ========================================
        // Auto-generate custom rates based on home state
        this.newTaxPlan.customTaxRates = [];
        this.getFormattedCustomRates();
      }
    }
  }
shouldShowCustomRate(customRate: any): boolean {
    if (!customRate?.formula) return true;

    try {
      const formula = _.isString(customRate.formula)
        ? JSON.parse(customRate.formula)
        : customRate.formula;

      return !(formula?.type === 'corporate' || formula?.type === 'individual');
    } catch {
      return true;
    }
  }

  stringifyCustomRateFormulas(){
    _.each(this.newTaxPlan.customTaxRates, (customTaxRate) => {
      try{
        if (!_.isString(customTaxRate.formula)) {
          customTaxRate.formula = JSON.stringify(customTaxRate.formula);
        }
      } catch (e){}
    });
  }

  filterStates(stateName) {
    this.states = _.filter(this.allProvinces, function(state){
      return state.country === stateName;
    });
  }

  /**
   * Normalize investmentOverriden flag for all plan strategies so payload defaults to false
   * (aligns with plan-strategies.component behavior when creating/updating lines).
   */
  private normalizeInvestmentOverrideFlag() {
    if (!Array.isArray(this.newTaxPlan?.strategies)) return;
    this.newTaxPlan.strategies.forEach((strategy: any) => {
      if (!strategy) return;
      strategy.investmentOverriden = false;
    });
  }

  saveSelectedStrategiesForPlan(type?, section?, selected?) {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // Handle UI navigation if section specified
      if (section) {
        this.currentSection = section;
        this.setSectionReviewedValuse(section);
      }
      return;
    }
    
    // Normal mode: Proceed with saving strategies
    const data: any[] = [];
    _.each(this.strategiesForReview, (strategy) => {
      data.push({strategyId : strategy.id});
    });
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.savePlanStrategiesForReview(this.org, this.user, this.newTaxPlan.id, data)
      .subscribe({
        next: (response) => {
          setTimeout(() => this.initTooltips());
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Strategies are saved for review');
          
          if (section) {
            if (selected) {
              this.validateRoutePath(section);
            } else {
              this.currentSection = section;
              this.secReview.strategiesInfo = true;
            }
          }

          if (type && type === 'draft') {
            this.draftSaved = true;
            setTimeout(() => {
              this.draftSaved = false;
            }, 5000);
          }

        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try{
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to save strategies');
          } catch (e){
            this.toastService.pop(TOAST_TYPE.error, 'Failed to save strategies');
          }
        }
      });
  }

  saveReviewStrategiesData(type?) {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // Handle draft save notification in memory
      if (type && type === 'draft') {
        this.draftSaved = true;
        setTimeout(() => {
          this.draftSaved = false;
        }, 5000);
      }
      return;
    }
    
    // Normal mode: Proceed with saving reviewed strategies
    const data: any[] = [];
    _.each(this.strategiesForReview, (strategy) => {
      if (strategy.reviwedData) {
        data.push(strategy.reviwedData);
      } else {
        data.push({
          'strategyId': '',
          'clientId': '',
          'parentClientId': '',
          'relatedPartyName': '',
          'goalDate': '',
          'associatedWith': '',
          'stateAssociatedWith': '',
          'sinceYear': '',
          'toYear': '',
          'recurring': strategy.recurring || false,
          'amount': 0
        });
      }
    });

    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.savePlanStrategiesForReview(this.org, this.user, this.newTaxPlan.id, data)
      .subscribe({
        next: (response) => {
          setTimeout(() => this.disposeTooltips());
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Reviewed strategies saved successfully');
          if (type && type === 'draft') {
            this.draftSaved = true;
            setTimeout(() => {
              this.draftSaved = false;
            }, 5000);
          } else if (type && type === 'updateSavings') {
            this.getDraftSelectedStrategies(true);
          }

        }, error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try{
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to save strategies');
          } catch (e){
            this.toastService.pop(TOAST_TYPE.error, 'Failed to save strategies');
          }
        }
      });
  }

  async saveCurrentDataAsDraft() {
    switch (this.currentSection) {
      case 'clientInfo':
        this.saveClient('draft');  // ✅ Has firewall
        break;
        
      case 'planInfo':
        if(this.isReviewPlan || this.newTaxPlan.id) {
          if (this.validateTaxplanData()) {
            this.updateClientStrategy('draft');  // ✅ Has firewall
          }
        } else {
          if (this.validateTaxplanData()) {
            this.createTaxPlan('draft');  // ✅ Has firewall
          }
        }
        break;
        
      case 'strategiesInfo':
        if (this.isRapEditMode) {
          // RAP SESSION: Always get AI suggestions
          let updatedOCRJson = null;
          if (this.isQuestionnarieInRapEnabled) {
            updatedOCRJson = await this.rapQuestionnaire.triggerBackgroundOCRChat("End Conversation", true) as any;
            this.newQuestionarieData = {
              ocrData: updatedOCRJson || '',
              chatId: this.chatId
            };
            this.updateQuestionarieData.emit(this.newQuestionarieData);
          }
          this.executeStrategyRequery(updatedOCRJson || null, this.currentSection);
        } else {
          // NORMAL FLOW
          this.saveSelectedStrategiesForPlan('draft');
        }
        break;
        
      case 'review':
        this.saveReviewStrategiesData('draft');  // ✅ Has firewall
        break;
        
      case 'roiFee':
        if (this.isRapEditMode) {
          // RAP SESSION: Sync to sandbox only
          this.syncRoiFeeToSandbox();
        } else {
          // NORMAL FLOW
          if (this.roiFeeInfo.draftRoiExist) {
            this.updateDraftDataForPlan()
          } else {
            this.saveDraftDataForPlan();
          }
        }
        break;
    }
  }

  createTasksAndPlan() {
    _.each(this.newTaxPlan.strategies, (strategy) => {
      let taskObj = _.find(this.tasksList, {strategyId: strategy.strategyId});
      if (taskObj) {
        taskObj['planLineId'] = strategy.id;
      }
    });

    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.createTasks(this.org, this.user, this.clientId, this.tasksList)
      .subscribe(response => {
        this.loadingService.triggerLoadingEvent(false);
        this.onCancelCreationOfStrategy.emit({fromTasksSection: true, plan: this.newTaxPlan});
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to create tasks');
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to create tasks');
        }
      });
  }

  createTaskForReviewField(fieldName, value, type?) {
    const task = {
      title: 'Review ' + fieldName,
      type: (type) ? type : '',
      value: value,
      dueDate: '',
      description: 'Review ' + fieldName
    };
    if (!this.validateTasks(task)) {
      this.tasksList.push(task);
      this.toastService.pop(TOAST_TYPE.success, 'Task added to the tasks list');
    }
    this.tasksList = _.uniqBy(this.tasksList, 'title');
  }

  validateTasks(task) {
    const title = task?.title != null ? String(task.title).trim() : '';
    if (!title) {
      this.toastService.pop(TOAST_TYPE.error, 'Task must have a title.');
      return true;
    }
    let taskExist = false;
    _.each(this.tasksList, (taskObj) => {
      const existingTitle = taskObj.title != null ? String(taskObj.title).trim() : '';
      if (existingTitle && existingTitle === title) {
        taskExist = true;
        this.toastService.pop(TOAST_TYPE.error, 'Task already exist');
      }
    });
    return taskExist;
  }

  onFilingSelect(status) {
    if (this.isRapEditMode) this.isRapSessionDirty = true;
    this.newTaxPlan.filingStatus = status.name;
    this.client.filingStatus = status.name;
    this.defaultStatus = status.name;
     if (this.newTaxPlan.homeState && this.newTaxPlan.taxYear && status.name) {
          let stateObj = _.find(this.states, {short: this.newTaxPlan.homeState});
          if (stateObj && stateObj.name) {
            this.newTaxPlan.individualStateRate = this.stateRateService.getIndStateRate(stateObj.name, status.name, this.newTaxPlan.taxableIncome, this.newTaxPlan);
            this.newTaxPlan.corporateStateRate = this.stateRateService.getCorporateStateRate(stateObj.name, status.name, this.newTaxPlan.taxableIncome, this.newTaxPlan);
          }
    }
  }

  getOCRSuggestions(onComplete?: () => void) {
    this.taxPlanningService.getOCRSuggestions(this.org, this.user, this.clientId, this.documentId)
      .subscribe(response => {
        this.formatOcrData(response);
        if (onComplete) onComplete();
      }, error => {
        this.loadingService.triggerLoadingEvent(false);
        try{
          let errorMsg = 'Failed to get suggestions';
          if (error?.error instanceof ProgressEvent) {
            errorMsg = 'Server error occurred. Please try again later.';
          }
          else if (typeof error?.error === 'string') {
            errorMsg = error.error;
          }
          else if (error?.error?.message) {
            errorMsg = error.error.message;
          }
         this.toastService.pop(TOAST_TYPE.error, errorMsg);
        } catch (e){
          this.toastService.pop(TOAST_TYPE.error, 'Failed to get suggestions');
        }
        if (onComplete) onComplete();
      });
  }

  formatedAiSuggestedStrategies(suggestions) {
    let suggestedStrategies: any[] = [];
    _.each(suggestions, (strategy) => {
      let strDescription = '';
      let recurringValue: any;
      let strId = '';
      let actualStrategy =  _.find(this.allTaxStrategies, {id: strategy.tax_strategy_id});
      let importStrategy =  _.find(this.allTaxStrategies, {importedFrom: strategy.tax_strategy_id});
      if (actualStrategy) {
        strId = actualStrategy.id;
        strDescription = actualStrategy.description;
        recurringValue = actualStrategy.recurring;
      } else if (importStrategy) {
        strId = importStrategy.id;
        strDescription = importStrategy.description;
        recurringValue = importStrategy.recurring;
      }
      let obj = {
        id: strId,
        name: strategy.tax_strategy_name,
        description: strDescription,
        aiSuggested: true,
        associatedWithName: strategy.federal_associated_rate,
        stateAssociatedWithName: strategy.state_associated_rate,
        suggestedInfo: strategy.description,
        planAmount: strategy.plan_amount,
        fieldDescriptor: strategy.field_descriptor || '',
        investmentDescription: strategy.investmentDescription || strategy.investment_description || '',
        recurring: recurringValue,
        totalSavings: this.numeralService.format('$0,0', strategy?.tax_saving?.totalSavings ?? 0),
        investment: strategy.investment?? null
      };
      if (obj.id) {
        suggestedStrategies.push(obj);
      }
    });
    return suggestedStrategies;
  }

  fillYears(){
    for (let i = this.currentYear - 5; i <= this.currentYear + 5; i++){
      this.years.push({id: i.toString(), name: i.toString()});
    }
  }

  setYear($event) {
    this.newTaxPlan['taxYear'] = $event.id;
    this.populateStateRates();
  }

  addTaskToTheList(task) {
    if (!task) return;
    const title = task.title != null ? String(task.title).trim() : '';
    if (!title) {
      this.toastService.pop(TOAST_TYPE.error, 'Task must have a title.');
      return;
    }
    if (!this.validateTasks(task)) {
      this.tasksList.push(task);
      this.toastService.pop(TOAST_TYPE.success, 'Task added to the tasks list');
    }
    this.tasksList = _.uniqBy(this.tasksList, 'title');
  }

  async validateRoutePath(section) {
    switch (this.currentSection) {
      case 'clientInfo':
        if (section === 'planInfo') {
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else if (!this.newTaxPlan.id && (section === 'strategiesInfo' || section === 'review' || section === 'tasksInfo') ) {
          this.currentSection = 'planInfo';
          this.setSectionReviewedValuse(this.currentSection);
          setTimeout(() => {
            this.toastService.pop(TOAST_TYPE.warning, 'Plan must be required.');
          }, 2000);
        } else if (this.newTaxPlan.id && section === 'strategiesInfo') {
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else if (this.newTaxPlan.id && section === 'review') {
          if (this.selectedStrategies && this.selectedStrategies.length === 0) {
            this.currentSection = 'strategiesInfo';
            this.setSectionReviewedValuse(this.currentSection);
            setTimeout(() => {
              this.toastService.pop(TOAST_TYPE.warning, 'Strategies must be required for review');
            }, 2000);
          } else {
            this.currentSection = section;
            this.setSectionReviewedValuse(this.currentSection);
          }
        }
        break;
      case 'planInfo':
        if (section === 'strategiesInfo') {
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        } else if (section === 'review') {
          if (this.selectedStrategies && this.selectedStrategies.length === 0) {
            this.currentSection = 'strategiesInfo';
            this.setSectionReviewedValuse(this.currentSection);
            setTimeout(() => {
              this.toastService.pop(TOAST_TYPE.warning, 'Strategies must be required for review');
            }, 2000);
          } else {
            this.currentSection = section;
            this.setSectionReviewedValuse(this.currentSection);
          }
        } else {
          this.currentSection = section;
          this.setSectionReviewedValuse(this.currentSection);
        }
        break;
      case 'strategiesInfo':
        if (this.isRapEditMode) {
          // ========================================
          // RAP SESSION: Get AI suggestions with hybrid payload
          // ========================================
          let updatedOCRJson = null;
          if (this.isQuestionnarieInRapEnabled) {
            // Try to get chat updates (may be null if questionnaire never started)
            updatedOCRJson = await this.rapQuestionnaire.triggerBackgroundOCRChat("End Conversation", true) as any;
            
            this.newQuestionarieData = {
              ocrData: updatedOCRJson || '',
              chatId: this.chatId
            };
            this.updateQuestionarieData.emit(this.newQuestionarieData);
          }
          // Always call AI with hybrid payload (user edits + questionnaire results)
          this.executeStrategyRequery(updatedOCRJson || null, section);
        } else {
          // ========================================
          // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
          // ========================================
          if (section === 'review') {
            if (this.selectedStrategies && this.selectedStrategies.length === 0) {
              this.currentSection = 'strategiesInfo';
              this.setSectionReviewedValuse(this.currentSection);
              setTimeout(() => {
                this.toastService.pop(TOAST_TYPE.warning, 'Strategies must be required for review');
              }, 2000);
            } else {
              this.currentSection = section;
              this.setSectionReviewedValuse(this.currentSection);
            }
          }
        }
        break;
      case 'review':
        if (section === 'tasksInfo') {
          if (this.reviewedStrategies && this.reviewedStrategies.length === 0) {
            this.currentSection = 'review';
            this.setSectionReviewedValuse(this.currentSection);
            setTimeout(() => {
              this.toastService.pop(TOAST_TYPE.warning, 'Selected strategies should be reviewed.');
            }, 2000);
          } else {
            this.currentSection = section;
            this.setSectionReviewedValuse(this.currentSection);
          }
        }
        break;
      case 'tasksInfo':
        break;
    }
  }

  view1040Document() {

    if (this.documentId) {
      if(this.ocrStatus == 'Error'){
        this.openView1040PdfPopup.emit();
      }else{
        this.loadingService.triggerLoadingEvent(true);
        this.taxStrategyServices.downloadDocument(this.user, this.org, this.documentId, '1040')
          .subscribe(response => {
            this.loadingService.triggerLoadingEvent(false);
            window.open(response.viewDocContentURL);
          }, error => {
            this.loadingService.triggerLoadingEvent(false);
            const errorMessage = 'Failed to download document';
            this.toastService.pop(TOAST_TYPE.error, errorMessage);
          });
      }
    }
  }

  viewQuestionarieDetails(){
    this.openViewQuestionariePopup.emit();
  }

  validateTasksAndUpdatePlan() {
    // Plan must be valid before PUT clientstrategy; tasks must be valid before POST tasks
    if (!this.validateTaxplanData()) return;
    this.normalizeTaskDueDates();
    if (!this.validTasksData()) return;
    this.updateClientStrategy('addStrategiesToPlan');
  }

  /**
   * Validates task due date format (MM/dd/yyyy) for backend DateUtils.getSQLDateFromString.
   * Reuses same rule as cost line dates.
   */
  private isValidTaskDueDateFormat(value: string | null | undefined): boolean {
    if (value == null || String(value).trim() === '') return true;
    return moment(value, 'MM/DD/YYYY', true).isValid();
  }

  /**
   * Normalizes task dueDate from yyyy-MM-dd (DB/ISO format) to MM/DD/YYYY (display format)
   * so that validation and the date picker both work correctly.
   * Safe to call on both normal flow and RAP edit — only converts if in ISO format.
   */
  private normalizeTaskDueDates() {
    _.each(this.tasksList, (task) => {
      if (task.dueDate && /^\d{4}-\d{2}-\d{2}$/.test(task.dueDate)) {
        const [y, m, d] = task.dueDate.split('-');
        task.dueDate = `${m}/${d}/${y}`;
      }
    });
  }

  validTasksData() {
    let isValid = true;
    const planStrategyIds = (this.newTaxPlan?.strategies || []).map((s: any) => s.strategyId || s.strategy_id || s.id);
    _.each(this.tasksList, (taskObj) => {
      if (!taskObj.title || (typeof taskObj.title === 'string' && !taskObj.title.trim())) {
        this.toastService.pop(TOAST_TYPE.error, 'Task must have a title.');
        isValid = false;
      }
      if (!taskObj.dueDate) {
        this.toastService.pop(TOAST_TYPE.error, 'The task must have due date.');
        isValid = false;
      } else if (!this.isValidTaskDueDateFormat(taskObj.dueDate)) {
        this.toastService.pop(TOAST_TYPE.error, 'Task due date must be in MM/dd/yyyy format.');
        isValid = false;
      }

    });
    return isValid;
  }

  scrollToBottom(): void {
    this.scrollContainer.nativeElement.scrollTop = this.scrollContainer.nativeElement.scrollHeight;
  }

  /**
   * Builds cost lines from roiFeeInfo for validation only (used in normal flow and RAP edit).
   * Returns null if roiFeeInfo is not available.
   */
  buildCostLinesForValidation(): any[] | null {
    if (!this.roiFeeInfo?.feeLineData) return null;
    const costLines: any[] = [];
    if (this.roiFeeInfo.feeLineData.amount && this.roiFeeInfo.feeLineData.amount > 0) {
      costLines.push({
        type: 'Pre Paid',
        amount: this.roiFeeInfo.feeLineData.amount,
        description: 'Prior year fee paid',
        frequency: this.roiFeeInfo.feeLineData.frequency,
        year: this.newTaxPlan.taxYear,
        associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
      });
    }
    if (this.roiFeeInfo.feeLineData.thirdPartyFee && this.roiFeeInfo.feeLineData.thirdPartyFee > 0) {
      costLines.push({
        type: 'Third Party',
        amount: this.roiFeeInfo.feeLineData.thirdPartyFee,
        description: 'Third party fee',
        frequency: this.roiFeeInfo.feeLineData.frequency,
        year: this.newTaxPlan.taxYear,
        associatedWith: '82c36191-8d6f-39e7-f711-947591551608'
      });
    }
    const proposedFeeLine = _.cloneDeep(this.roiFeeInfo.feeLineData);
    proposedFeeLine.amount = this.roiFeeInfo.finalY1ImplementationValue || 0;
    proposedFeeLine.frequency = this.roiFeeInfo.feeLineData.frequency;
    const calcString = _.cloneDeep(this.roiFeeInfo.implementationFeeTypes);
    proposedFeeLine.implementationCalc = JSON.stringify(calcString);
    costLines.push(proposedFeeLine);
    _.each(costLines, (cost: any) => {
      if (cost.fromMonth) cost.fromMonth = moment(cost.fromMonth).format('MM/DD/YYYY');
      if (cost.toMonth) cost.toMonth = moment(cost.toMonth).format('MM/DD/YYYY');
    });
    return costLines;
  }

  saveFeeForPlan() {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // RAP SESSION: No database save - data stays in sandbox
      // ROI fee data will be synced to sandbox via syncRoiFeeToSandbox()
      return true;  // Return success to allow navigation
    }
    
    // ========================================
    // NORMAL FLOW 
    // ========================================
    const costLines = this.buildCostLinesForValidation();
    if (!costLines) return false;
    if (!this.validateCostLines(costLines)) return false;
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateCostLines(this.org, this.user, this.newTaxPlan.id, costLines)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Fees updated successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.error, 'Failed to update Fees');
        }
      });
  }

  /**
   * Validates that a date string is in the format required by backend DateUtils.getSQLDateFromString (Constants.DATE_FORMAT = MM/dd/yyyy).
   * Used for ROI Fee cost line fromMonth/toMonth so invalid dates are caught on the frontend instead of being stored as null.
   */
  private isValidCostLineDateFormat(value: string | null | undefined): boolean {
    if (value == null || String(value).trim() === '') return true;
    return moment(value, 'MM/DD/YYYY', true).isValid();
  }

  validateCostLines(costData){
    const base = this;
    let isFineToSave = true;
    _.each(costData, (costLine) => {
      if (!costLine.type) {
        base.toastService.pop(TOAST_TYPE.error, 'Type cannot be empty');
        isFineToSave = false;
      } else if (costLine.type == 'Recurring') {
        if (costLine.frequency == 'Custom') {
          if (!costLine.fromMonth) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'Start date cannot be empty');
          } else if (!base.isValidCostLineDateFormat(costLine.fromMonth)) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'Start date must be in MM/dd/yyyy format');
          } else if (!costLine.toMonth) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'End date cannot be empty');
          } else if (!base.isValidCostLineDateFormat(costLine.toMonth)) {
            isFineToSave = false;
            base.toastService.pop(TOAST_TYPE.error, 'End date must be in MM/dd/yyyy format');
          }
        } else if (!costLine.year) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Year cannot be empty');
        }
      } else if (costLine.type != 'Priceless') {
        if (!costLine.year) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Year cannot be empty');
        } else if (!costLine.associatedWith) {
          isFineToSave = false;
          base.toastService.pop(TOAST_TYPE.error, 'Please select an associated with rate');
        }
      }
    });
    return isFineToSave;
  }

  /**
   * Validates that the payload matches backend jsonInput: valid JSON with draftPlanId (string) and jsonData (object).
   * Used before create/update draft plan to avoid 400 "Invalid input".
   */
  private isValidDraftPlanJsonInput(payload: unknown): { valid: boolean; message?: string } {
    if (payload == null || typeof payload !== 'object' || Array.isArray(payload)) {
      return { valid: false, message: 'Invalid input: payload must be an object' };
    }
    const p = payload as Record<string, unknown>;
    if (typeof p.draftPlanId !== 'string' || p.draftPlanId.trim() === '') {
      return { valid: false, message: 'Invalid input: draftPlanId is required and must be a non-empty string' };
    }
    if (p.jsonData == null || typeof p.jsonData !== 'object' || Array.isArray(p.jsonData)) {
      return { valid: false, message: 'Invalid input: jsonData is required and must be an object' };
    }
    try {
      JSON.stringify(payload);
    } catch {
      return { valid: false, message: 'Invalid input: payload is not JSON-serializable' };
    }
    return { valid: true };
  }

  saveDraftDataForPlan() {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // RAP SESSION: No database save - data stays in sandbox
      // Draft data is already synced to sandbox via syncRoiFeeToSandbox()
      return;
    }

    // ========================================
    // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
    // ========================================
    let calcString = _.cloneDeep(this.roiFeeInfo.implementationFeeTypes);
    let obj = {
      roiFee: {
        feeLineData: this.roiFeeInfo.feeLineData,
        proposedY1Value: this.roiFeeInfo.finalY1ImplementationValue || 0,
        proposedY1ValueImplCalc: calcString
      }
    };
    let data = {
      draftPlanId: this.newTaxPlan.id,
      jsonData: obj
    };
    const validation = this.isValidDraftPlanJsonInput(data);
    if (!validation.valid) {
      this.toastService.pop(TOAST_TYPE.error, validation.message ?? 'Invalid draft plan data');
      return;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.saveDraftForPlan(this.org, this.user, data)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Saved successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try {
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to save');
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to save');
          }
        }
      });
  }

  updateDraftDataForPlan() {
    // ============================================================================
    // FIREWALL: Block if in RAP edit mode
    // ============================================================================
    if (this.isRapEditMode && !this.isFinalSaveInProgress) {
      // RAP SESSION: No database update - data stays in sandbox
      // Draft data is already synced to sandbox via syncRoiFeeToSandbox()
      return;
    }

    // ========================================
    // NORMAL FLOW (EXACT COPY FROM DEVELOPMENT)
    // ========================================
    let calcString = _.cloneDeep(this.roiFeeInfo.implementationFeeTypes);
    let obj = {
      roiFee: {
        feeLineData: this.roiFeeInfo.feeLineData,
        proposedY1Value: this.roiFeeInfo.finalY1ImplementationValue || 0,
        proposedY1ValueImplCalc: calcString
      }
    };
    const updatePayload = { draftPlanId: this.newTaxPlan.id, jsonData: obj };
    const validation = this.isValidDraftPlanJsonInput(updatePayload);
    if (!validation.valid) {
      this.toastService.pop(TOAST_TYPE.error, validation.message ?? 'Invalid draft plan data');
      return;
    }
    this.loadingService.triggerLoadingEvent(true);
    this.taxPlanningService.updateDraftForPlan(this.org, this.user, this.newTaxPlan.id, obj)
      .subscribe({
        next: (response) => {
          this.loadingService.triggerLoadingEvent(false);
          this.toastService.pop(TOAST_TYPE.success, 'Updated successfully');
        },
        error: (error) => {
          this.loadingService.triggerLoadingEvent(false);
          try {
            this.toastService.pop(TOAST_TYPE.error, error.message ? error.message : 'Failed to update');
          } catch (e) {
            this.toastService.pop(TOAST_TYPE.error, 'Failed to update');
          }
        }
      });
  }

handleQuestionnarieSectionChange(value: number) {
  this.questionnaireTrack = value;
}

validateReviewedStrategiesData(): boolean {
  const yearRegex = /^\d{4}$/;

  for (const strategy of this.strategiesForReview) {
    if (strategy.reviwedData) {
      const { sinceYear, toYear } = strategy.reviwedData;
      const strategyName = strategy.name;

      // Validate Start Year
      if (!yearRegex.test(sinceYear)) {
        this.toastService.pop(TOAST_TYPE.error, `Please enter Start Year in YYYY format for "${strategyName}" strategy`, null, 5000);
        return false;
      }

      // Validate End Year format
      if (toYear && !yearRegex.test(toYear)) {
        this.toastService.pop(TOAST_TYPE.error, `Please enter End Year in YYYY format for "${strategyName}" strategy`, null, 5000);
        return false;
      }

      // Validate Year Range
      if (toYear && parseInt(toYear) < parseInt(sinceYear)) {
        this.toastService.pop(TOAST_TYPE.error, `End Year cannot be earlier than Start Year for "${strategyName}" strategy`, null, 5000);
        return false;
      }
    }
  }

  return true; // Return true if all strategies pass validation
}
normalizeFilingStatus(status: string): string {
  const normalized = status.toLowerCase().trim();

  if (['married filing jointly (even if only one had income)', 'married filing jointly', 'mfj'].includes(normalized)) {
    return 'MFJ';
  }
  if (['married filing separately', 'mfs'].includes(normalized)) {
    return 'MFS';
  }
  if (['head of household', 'hoh', 'head of household (hoh)'].includes(normalized)) {
    return 'HOH';
  }
  if(['qualifying surviving spouse (qss)', 'qualifying surviving spouse', 'qss'].includes(normalized)) {
    return 'QSS';
  }
  if (normalized === 'single') {
    return 'Single';
  }
  if (normalized === 'estate') {
    return 'Estate';
  }
  if (normalized === 'trust') {
    return 'Trust';
  }

  return 'Single';
}

}
